//#region import
import {
  ActionIcon,
  Box,
  Button,
  CSSProperties,
  Card,
  Collapse,
  Divider,
  Flex,
  Grid,
  Group,
  Input,
  Menu,
  Modal,
  NumberFormatter,
  NumberInput,
  Select,
  Switch,
  Table,
  Tabs,
  Text,
  TextInput,
  Textarea,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import {
  useDebouncedCallback,
  useDebouncedState,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCheck,
  IconCreditCard,
  IconDiscount,
  IconMaximize,
  IconMaximizeOff,
  IconMenu2,
  IconMinus,
  IconPlus,
  IconPrinter,
  IconSearch,
  IconTrash,
  IconTruck,
  IconWindow,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { useLocation, useNavigate } from "react-router-dom";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SocketExtension } from "../../../_base/socket/socket";
import { CREATEORDERSUCCESS } from "../../../_base/socket/ToplicList";
import { styleCellTable } from "../../../_setup/navdata/baseStyleCellTable";
import EditableTextWithOptions from "../../../common/selectValue";
import SelectBuildPc from "../../../common/selectValue/SelectBuildPc";
import SelectPaymentMethod from "../../../common/selectValue/SelectPaymentMethod";
import { _localizationSales } from "../../../config/location";
import { cobalt_blue, orange } from "../../../const/variables";
import { DepartmentModel } from "../../../model/DepartmentModel";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  OrderHeader,
  dataOrderDetailTable,
} from "../../../model/SaleOrderModel";
import { ProductModel } from "../../../model/TblDMItem";
import { TblDMPaymentMethod } from "../../../model/TblDMPaymentMethod";
import {
  ItemDetailPriceModel,
  TblItemPromotionModel,
  itemAddOnPromotionModel,
  itemGiftPromotionModel,
} from "../../../model/TblItem";
import "../../../Styles/TableBodyCell.module.css";
import { LineType, OrderStatus } from "../orderStatus";
import PrintInvoice from "../PrintInvoice";
import { exchangeReasons, returnReasons } from "../ReturnOrder/ReasonOption";
import {
  formatDateString,
  formatOrderDate,
  getTotalQuality,
  handleCheckBackgroundColor,
  handleCheckChooseProduct,
  handleCheckIsSuccessValidateItem,
  handleGetNameBranch,
  handleGetNameDepartment,
  handleGetNameEmployeeAll,
  handleGetTechnicialRequireId,
  handleGetTechnicialRequireName,
  handleKeyDown,
  handlePaymentChange,
  handleQuantityChange,
  handlerRenderOptionSelect,
  parseAttribute19,
} from "./Helper/HelperFunction";
import ShipCompanyTable from "./ModalComponent/ChooseShipCompany";
import ChooseShipDepartment from "./ModalComponent/ChooseShipDepartment";
import CustomerDetail from "./ModalComponent/CustomerDetail";
import ItemSelectionModal from "./ModalComponent/ItemSelectionModalProps";
import CustomerInformation from "./ModalComponent/ModalCustomerInformation";
import ModalDeliveryInformation from "./ModalComponent/ModalDeliveryInformation";
import { PaymentMethod } from "./ModalComponent/ModalPayment";
import { PaymentMethodMb } from "./ModalComponent/ModalPaymentMb";
import PaymentDetails from "./ModalComponent/PaymentDetails";
import VoucherRefactor from "./ModalComponent/Voucher";
import {
  TableSelectProps,
  customerCheck,
  dataCreateSalesOrder,
} from "./Model/modelRetailOrder";
import styles from "./RetailOrder.module.css";
import { SelectListItemModel } from "../../../model/SelectListItem";
const ReturnOrderAll = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFetchDataCalledRef = React.useRef(false);
  const isSetDefaultBuildPc = React.useRef(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [oldProduct, setOldProduct] = useState<any>({});
  const [optionsReason, setOptionsReason] = useState<SelectListItemModel[]>([]);
  const [bulkReasonValue, setBulkReasonValue] = useState("");

  //#region   khai báo state
  const [accountantId, setAccountantId] = useState(0);
  const [accountantName, setAccountantName] = useState("");
  const [isPaymentMbSuccess, setIsPaymentMbSuccess] = useState(false);

  const [selectedBank, setSelectedBank] = useState("");
  const [modalType, setModalType] = useState(""); // COD, "Công nợ", "Trả góp"
  const [installmentInfo, setInstallmentInfo] = useState({
    installmentType: "",
    companyName: "",
    contractCode: "",
    cardType: "",
  });

  // State cho thông tin công nợ
  const [debtInfo, setDebtInfo] = useState({
    dueDate: "",
  });

  // Danh sách các ngân hàng (ví dụ)
  const bankOptions = [
    { value: "VCB-930", label: "VCB-930" },
    { value: "TPB-604", label: "TPB-604" },
    { value: "VCB-813", label: "VCB-813" },
    { value: "VCB-762", label: "VCB-762" },
    { value: "PAYOO", label: "PAYOO" },
    { value: "VN PAY", label: "VN PAY" },
  ];
  const [transactionCodeReserve, setTransactionCodeReserve] = useState<
    string | null
  >(null); // Mã giao dịch
  const [transactionCodeMb, setTransactionCodeMb] = useState<string | null>(
    null,
  ); // Mã giao dịch MB động
  const [selectedBankReserve, setSelectedBankReserve] = useState<string | null>(
    null,
  ); // Ngân hàng dự phòng
  const [modeSearch, setModeSearch] = useState("SP"); //SP là tìm sản phẩm , DV là tìm dịch vụ
  const [isReturnProduct, setIsReturnProduct] = useState(false); //SP là tìm sản phẩm , DV là tìm dịch vụ
  const [userLogin, setUserLogin] = useState<any>();
  const [listSerial, setListSerial] =
    useState<{ value: string; label: string }[]>();
  const [totalKM, setTotalKM] = useState(0);
  const [totalKMLine, setTotalKMLine] = useState(0);
  const [totalXGDetail, setTotalXGDetail] = useState(0);
  const [totalReturnFee, setTotalReturnFee] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  // phần 5 hàng thanh toán
  const [cashPayment, setCashPayment] = useState(0);
  const [bankTransfer, setBankTransfer] = useState(0);
  const [cardPayment, setCardPayment] = useState(0);
  const [vnpayPayment, setVnpayPayment] = useState(0);
  const [anotherPayment, setAnotherPayment] = useState(0);
  //
  const [totalPaid, setTotalPaid] = useState(0);
  const [deferredPayment, setDeferredPayment] = useState(0);
  const [contractcode, setContractcode] = useState("");
  const [listEmployeeSales, setListEmployeeSales] = useState<any[]>([]);
  const [listBranch, setListBranch] = useState<any[]>([]);
  const [branchId, setBranchId] = useState<number>();
  const [branchName, setBranchName] = useState<string>("");
  const [employeeSalesId, setEmployeeSalesId] = useState("");
  const [employeeSalesRevenueId, setEmployeeSalesRevenueId] = useState("");
  const [listDepartment, setListDepartment] = useState<DepartmentModel[]>([]);
  const [departmentId, setDepartmentId] = useState<Number>();
  const [employeeSalesName, setEmployeeSalesName] = useState("");
  const [employeeSalesRevenueName, setEmployeeSalesRevenueName] = useState("");
  const [department, setDepartment] = useState("");
  const [orderStatus, setOrderStatus] = useState<string>("noCreate");
  const [shipping, setShipping] = useState("Nhận tại cửa hàng");
  const [shipingVendor, setShipingVendor] = useState("");
  const [payLaterMethod, setPayLaterMethod] = useState("Không");
  const [saleChanelList, setSaleChanelList] = useState<any[]>();
  const [saleChanelId, setSaleChanelId] = useState<number>();
  const [saleChanel, setSaleChanel] = useState("Khách đến showroom");
  const [height, setHeight] = useState(0);
  const [isError, setIsError] = useState(false);
  const [listAdd, setListAdd] = useState<dataOrderDetailTable[]>([]);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [dataProducts, setDataProducts] = useState<ProductModel[]>([]);
  const [valueDebounced, setValueDebounced] = useDebouncedState("", 500);
  const [paymentDone, setPaymentDone] = useState<string[]>([]);
  const [idPrint, setIdPrint] = useState<number | null>(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [loading, { close: closeLoading, open: openLoading }] =
    useDisclosure(false);
  const [isCollapse, { toggle: toggleCollapse }] = useDisclosure(false);
  const [truPhanBo, setTruPhanBo] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false); // State điều khiển modal
  const [modalData, setModalData] = useState<any[]>([]); // Dữ liệu hiển thị trong modal
  const [totalPhanBo, setTotalPhanBo] = useState(0); // Dữ liệu hiển thị trong modal

  //#region  state object
  const [listBuyerName, setListBuyerName] = useState([]);
  const [dataDeliveryInformation, setDataDeliveryInformation] = useState<any>();
  const [dataPayment, setDataPayment] = useState<any>();
  const [dataPaymentLatter, setDataPaymentLatter] = useState<any>();
  const [orderHeaderRef, setOrderHeaderRef] = useState<any>();
  const [orderHeader, setOrderHeader] = useState<OrderHeader>({
    id: 0, // ID của đơn hàng - OK
    orderNumber: "", // Số đơn hàng - đã ghép vào field "Mã đơn hàng"
    orderTypeId: 3, // Loại đơn hàng (2 là đơn hàng lẻ)
    orderDate: "2024-01-01T01:00:00.000Z", // Ngày đặt hàng - đã ghép vào field "Thời gian"
    orderStatus: "DON_HANG_TAM", // Trạng thái đơn hàng (pending: đang chờ) -đã ghép vào trạng thái góc trên phải
    note: "", // Ghi chú đơn hàng - đã ghép vào field "Ghi chú"
    orgId: 0, // ID tổ chức
    invOrgId: 0, // ID tổ chức liên quan đến kho hàng
    deptId: 0, // ID phòng ban
    divisionId: 0, // ID bộ phận
    saleChanelId: 0, // ID kênh bán hàng
    sourceOrderNumber: "", // Số đơn hàng nguồn
    sourceDocument: "", // Tài liệu nguồn
    sourceInvoices: "", // Hóa đơn nguồn
    custId: 0, // ID khách hàng
    custGroupId: 0, // ID nhóm khách hàng
    contactPersonId: 0, // ID người liên hệ
    billToLocationId: 0, // ID địa điểm hóa đơn
    shipToLocationId: 0, // ID địa điểm giao hàng
    invoiceSerial: "", // Số serial hóa đơn
    invoiceNumber: "", // Số hóa đơn
    invoiceDate: "2024-07-16T04:10:09.167Z", // Ngày hóa đơn
    taxCode: "", // Mã số thuế
    taxAddr: "", // Địa chỉ thuế
    amountTotal: 0, // Tổng số tiền
    amountDiscount: 0, // Số tiền giảm giá
    amountVoucher: 0, // Số tiền voucher
    amountVat: 0, // Số tiền thuế VAT
    currentcyCode: "", // Mã tiền tệ
    currentcyRate: 0, // Tỷ giá tiền tệ
    amountPaid: 0, // Số tiền đã thanh toán
    amountRemaining: 0, // Số tiền còn lại
    paymentType: "", // Loại thanh toán
    paymentStatus: "", // Trạng thái thanh toán
    paymentMethod: "", // Phương thức thanh toán
    paymentDue: 0, // Hạn thanh toán
    saleId: 0, // ID người bán hàng
    managerId: 0, // ID quản lý
    approveId: 0, // ID người duyệt
    approveNote: "", // Ghi chú người duyệt
    rejectNote: "", // Ghi chú từ chối
    shipngType: "", // Loại vận chuyển
    shipingVendor: "", // Nhà cung cấp vận chuyển
    shippingCode: "", // Mã vận chuyển
    shippingStatus: "", // Trạng thái vận chuyển
    shippingPriority: "", // Ưu tiên vận chuyển
    shippingDate: "2024-07-16T04:10:09.167Z", // Ngày vận chuyển
    shippingNote: "", // Ghi chú vận chuyển
    technicalChecked: 0, // Kiểm tra kỹ thuật
    technicalNote: "", // Ghi chú kỹ thuật
    clientId: 0, // ID khách hàng
    createBy: 0, // ID người tạo
    createDate: "2024-07-16T04:10:09.167Z", // Ngày tạo
    lastUpdateBy: 0, // ID người cập nhật cuối cùng
    lastUpdateDate: "2024-07-16T04:10:09.167Z", // Ngày cập nhật cuối cùng
    salesShift: "", // Ca bán hàng
    printInvoiceCheck: 0, // Kiểm tra in hóa đơn
    technicalRequired: 0,
    contractcode: "",
    discountAdded: 0,
    discountAddedTotal: 0,
    orderNumberLink: "",
    attribute97: "",
  });

  const [customerCheck, setCustomerCheck] = useState<customerCheck>({
    id: 0,
    companyName: null,
    code: null,
    name: null,
    contact: null,
    address: null,
    telephoneNumber: null,
    fax: null,
    email: null,
    taxCode: "",
    type: null,
    active: null,
    description: null,
    sex: null,
    groupId: 0,
    country: null,
    province: null,
    district: null,
    commune: null,
    provinceName: null,
    districtName: null,
    communeName: null,
    birthOfDate: null,
    groupName: null,
    debtLimit: null,
    debtTerm: null,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
  });

  // Bắt đầu phần logic cho đổi trả
  const [serialNumber, setSerialNumber] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [serialList, setSerialList] = useState<string[]>([""]);

  const [dataAllocate, setDataAllocate] = useState([]);
  const [isDisablePhanBo, setIsDisablePhanBo] = useState(false);

  const handleEnterPressAll = async (
    e: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (orderNumber && e.key === "Enter") {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${orderNumber}`;
      const data = await repositoryPos.get<MessageResponse<any>>(url);
      if (data && data?.success) {
        setOrderHeader((prev) => ({
          ...prev,
          custId: data?.data?.orderHeader.custId,
          saleId: data?.data?.orderHeader.saleId,
          attribute18: data?.data?.orderHeader.attribute18,
          attribute27: data?.data?.orderHeader.attribute27,
          attribute16: data?.data?.orderHeader.attribute16,
          attribute36: data?.data?.orderHeader.attribute36,
          saleChanelId: data?.data?.orderHeader.saleChanelId,
        }));
      }

      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/tblitem/get-details-by-ordernumber?orderNumber=${orderNumber}`,
      );

      if (response?.data?.tblOrderDetails) {
        const updatedList = response?.data?.tblOrderDetails?.map(
          (item: any) => ({
            ...item,
            itemName: item.attribute30,
            attribute13: item.attribute22,

            attribute22: "",
            attribute19: orderNumber,
            lineTyle: item?.lineTyle === "DV" ? "DV" : "HT", // Giữ nguyên lineTyle nếu là "DV"
            attribute2: "Đ1",
            attribute6: "new",
            attribute7: "du",
            attribute8: "hoat_dong_tot",
          }),
        );

        setListAdd(updatedList);
        setOrderHeader((prev) => {
          const raw = response?.data?.orderHeader?.attributeValue3 ?? "0";
          const num = Number(raw);
          const neg = -num;
          const safeNum = Object.is(neg, -0) ? 0 : neg;
          return { ...prev, attributeValue3: String(safeNum) };
        });
        setOrderNumber(""); // Xóa ô nhập
      }
    }
  };

  console.log("ssss", orderHeader);

  const handleEnterPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && serialNumber.trim() !== "") {
      const newSerialList = [serialNumber.trim()]; // Tạo mảng chỉ chứa 1 phần tử hiện tại
      setSerialList(newSerialList); // Cập nhật state

      handleSearchSerial(newSerialList); // Gọi API với mảng serial mới
    }
  };

  const handleSearchSerial = async (serials: string[]) => {
    try {
      const response = await repositoryPos.post<MessageResponse<any>>(
        "api/v1/TblItem/search-serial",
        serials,
      );
      if (response?.success && response?.data) {
        if (response?.data?.length === 0) {
          NotificationExtension.Fails(
            "Không tìm thấy serial trong đơn hàng nào!",
          );
          return;
        }

        if (response?.data?.length > 1) {
          // Nếu có nhiều hơn 1 item, hiển thị modal để chọn
          setModalData(response.data);
          console.log("response.data", response.data);
          setIsModalVisible(true); // Mở modal
          return;
        }
        // Nếu chỉ có 1 item, thêm trực tiếp vào danh sách
        const updatedData = response?.data?.map((item: any) => {
          const attribute28Value = Number(item.attribute28) || 0; // Chuyển về số, nếu null hoặc không hợp lệ thì mặc định là 0
          const attribute29Value = Number(item.attribute29) || 0; // Chuyển về số, nếu null hoặc không hợp lệ thì mặc định là 0
          return {
            ...item,
            priceFinal: item.priceFinal - attribute28Value - attribute29Value,
            totalLineAmount:
              item.totalLineAmount - attribute28Value - attribute29Value,
            attribute2: "Đ1",
            attribute6: "new",
            attribute7: "du",
            attribute8: "hoat_dong_tot",
            // priceOnPriceList: item.priceOnPriceList - attribute28Value,
          };
        });
        console.log("updatedData", updatedData);
        addItemToList(updatedData[0]);
      }
    } catch (error) {
      console.error("Lỗi gọi API:", error);
      NotificationExtension.Fails("Lỗi trong quá trình tìm kiếm serial.");
    }
  };

  console.log("listAdddd", listAdd);

  // Hàm thêm item vào listAdd
  const addItemToList = (newItem: any) => {
    console.log("newItemnewItemnewItem", newItem);
    setListAdd((prevList) => {
      // Kiểm tra trùng lặp dựa trên attribute13
      if (prevList.some((item) => item.attribute13 === newItem.attribute13)) {
        NotificationExtension.Fails("Serial đã tồn tại trong danh sách.");
        return prevList;
      }

      // Thêm item mới với các thuộc tính bổ sung

      const updatedItem = {
        ...newItem,
        quality: -1,
        lineTyle: newItem?.lineTyle === "KM" ? "KM" : "HT", // Giữ nguyên lineTyle nếu là "KM"
      };

      // NotificationExtension.Success("Thêm sản phẩm đổi trả thành công");
      return [...prevList, updatedItem];
    });
  };

  // Kết thúc phần logic cho đổi trả

  const deliveryFee =
    listAdd.length > 0 ? dataDeliveryInformation?.deliveryFee || 0 : 0;

  //#region handle FUNC

  const handleAddOldProduct = (oldProduct: any, price: any, serial: any) => {
    try {
      const newProduct = {
        attribute13: serial?.toUpperCase(),
        attribute23: "", // Adjust if additional fields are needed
        attribute21: "1", // Adjust if additional fields are needed
        id: 0, // Default ID, replace if necessary
        itemCode: oldProduct?.itemCode,
        itemName: oldProduct?.itemName,
        primaryUomCode: "", // Adjust based on actual data
        orgId: 0, // Replace if organizational ID exists
        warehouse: "", // Update if needed
        priceType: "Giá niêm yết",
        quality: -1,
        discountRate: 0,
        discountAmount: 0,
        discountAdded: 0,
        priceFinal: parseFloat(price) || 0,
        vatRate: 0, // Default VAT rate
        vatAmount: 0, // Default VAT amount
        totalLineAmount: parseFloat(price) || 0,
        note: "",
        lineTyle: "HT",
        orderHeaderId: 0,
        deptId: 0,
        itemId: oldProduct?.itemId,
        linkToItemId: 0,
        uomCode: "",
        priceListId: 0,
        priceOnPriceList: parseFloat(price) || 0,
        idPromote: 0,
        idPromoteList: "",
        linkToLineId: 0,
        printInvoiceCheck: 0,
        promotePostPaid: "",
        promoteClearCheck: 0,
        promoteClearDate: "",
        prometeClearPersionId: 0,
        prometeClearClientId: "",
        clientId: 0,
        workShiftId: 0,
        createBy: 0,
        createDate: "",
        lastUpdateBy: 0,
        lastUpdateDate: "",
        subInvId: 0,
        listIdPromotion: [],
        listIdAddOn: [],
        listIdGift: [],
        promotionDiscountPercent: 0,
        promotionDiscountAmount: 0,
      };
      setListAdd((prevList) => [...prevList, newProduct]);
      table.setEditingRow(null);
    } catch (error) {
      console.error("Error in handleAddOldProduct:", error);
    }
  };

  const handleSelectShipingVendor = (value: any) => {
    setShipingVendor(value?.DoiTacVanChuyen);
  };
  const handleRenderOptionListAdd = (
    listAdd: any[],
  ): { value: string; label: string }[] => {
    return listAdd
      .filter((item) => item.lineTyle === "HT" && item.attribute13)
      .map((item) => ({
        value: item.attribute13,
        label: item.attribute13,
      }));
  };

  const debouncedNoteChange = useDebouncedCallback(
    (value) =>
      setOrderHeader((prev) => ({
        ...prev,
        note: value,
      })),
    300, // Độ trễ 300ms
  );

  const debouncedCashierNoteChange = useDebouncedCallback(
    (value) =>
      setOrderHeader((prev) => ({
        ...prev,
        attribute23: value,
      })),
    300,
  );

  const handleApprovedSalesOrder = async () => {
    if (!orderHeader.custId) {
      NotificationExtension.Warn("Chưa có thông tin khách hàng !");
      return;
    }
    // prepare orderDetail and attach shipping fee into a line if needed
    const orderDetailForApprove = [...listAdd];
    const shippingFeeForApprove = Number(
      dataDeliveryInformation?.feeShip ?? orderHeader?.attributeValue3 ?? 0,
    );
    if (
      shippingFeeForApprove &&
      shippingFeeForApprove !== 0 &&
      orderDetailForApprove.length > 0
    ) {
      const idxApp = orderDetailForApprove.findIndex(
        (i) => i?.lineTyle !== "KM" && i?.lineTyle !== "DV",
      );
      const attachIdxApp = idxApp >= 0 ? idxApp : 0;
      orderDetailForApprove[attachIdxApp] = {
        ...orderDetailForApprove[attachIdxApp],
        totalLineAmount:
          (Number(orderDetailForApprove[attachIdxApp].totalLineAmount) || 0) +
          shippingFeeForApprove,
      };
    }

    const response = await repositoryPos.post<
      MessageResponse<dataCreateSalesOrder>
    >("/api/v1/CreateSellItem/approve", {
      orderDetail: orderDetailForApprove,
      orderHeader: {
        ...orderHeader,
        invOrgId: branchId ? branchId : 488,
        orgId: branchId ? branchId : 488,
        saleChanelId: saleChanelId ? saleChanelId : 67,
        saleId: employeeSalesId,
        deptId: departmentId,
        attribute2: accountantId, //Nguyễn Trang Quyên-0009
        contractcode: contractcode,
        orderTypeId: 3,
        branchId: branchId ? branchId : 488,
        amountTotal: payableAmount,
        amountDiscount: totalKMLine,
        amountVat: 0,
        discountAdded: totalXGDetail,
        attribute1: JSON.stringify(dataDeliveryInformation),
        createDate: orderHeader?.orderDate,
        approveStatus: "2",
      },
      isApprove: true,
    });

    if (response && response.success) {
      setOrderStatus("DON_HANG_DA_DUYET_GIAM");
      NotificationExtension.Success("Duyệt giảm giá thành công !");
      SocketExtension.SendMessageToTopic<any>({
        topic: CREATEORDERSUCCESS,
        data: "",
      });
    } else {
      NotificationExtension.Fails(response?.message);
    }
  };

  const handleChangeQuantity = (e: any, row: any) => {
    handleQuantityChange(e, row, branchId, location, setListAdd);
  };

  const handleQuantityChangeReturn = async (e: any, row: any) => {
    // Kiểm tra nếu giá trị nhập vào không phải số âm
    if (e >= 0) {
      // Cảnh báo lỗi
      NotificationExtension.Warn("Số lượng hàng trả phải là số âm!");
      return;
    }

    // Cập nhật lại danh sách với số lượng mới
    setListAdd((prevData: any) => {
      const updatedData = prevData.map((item: any, i: any) =>
        i === row.index
          ? {
              ...item,
              attribute25: "1",
              quality: e || null,
              totalLineAmount: row?.original?.priceFinal * e,
            }
          : item,
      );

      return updatedData.map((item: any) =>
        row?.original?.listIdGift?.includes(item?.id)
          ? {
              ...item,
              // Tạm bỏ logic thay đổi số lượng của quà
              // quality: e || null,
            }
          : item,
      );
    });
  };

  // Hàm mở modal theo loại
  const handleOpenModal = (type: string) => {
    setModalType(type);
  };

  // Hàm đóng modal
  const handleCloseModal = () => {
    setModalType("");
  };

  // Hàm xử lý lưu thông tin trả góp
  const handleSaveInstallment = () => {
    console.log("Thông tin trả góp:", installmentInfo);
    handleCloseModal();
  };

  // Hàm xử lý lưu thông tin công nợ
  const handleSaveDebt = () => {
    console.log("Thông tin công nợ:", debtInfo);
    handleCloseModal();
  };

  const handleChangePrice = (value: any, key: string) => {
    handlePaymentChange(key, value, {
      setCashPayment,
      setBankTransfer,
      setCardPayment,
      setVnpayPayment,
      setAnotherPayment,
    });
  };
  const handleChooseCustomer = (value: any, isChooseCustomer: any) => {
    if (isChooseCustomer) {
      // Chỉ cập nhật attribute1 nếu isChooseCustomer = true
      setCustomerCheck({
        ...customerCheck,
        debtLimit: value?.debtLimit,
        debtTerm: value?.debtTerm,
        attribute1: value?.attribute1,
      });
    } else {
      // Cập nhật toàn bộ thông tin khách hàng
      setCustomerCheck({
        ...customerCheck,
        code: value?.code,
        name: value?.name,
        telephoneNumber: value?.telephoneNumber,
        id: value?.id,
        type: value?.type,
        province: value?.province,
        district: value?.district,
        commune: value?.commune,
        address: value?.address,
        attribute1: value?.attribute1,
        attribute4: value?.attribute4,
        companyName: value?.companyName,
        debtLimit: value?.debtLimit,
        debtTerm: value?.debtTerm,
        groupId: value?.groupId,
        taxCode: value?.taxCode,
        email: value?.email,
      });

      setOrderHeader({ ...orderHeader, custId: value?.id });

      // Kiểm tra nếu listBuyerName có phần tử hợp lệ thì cập nhật state
      if (
        Array.isArray(value?.listBuyerName) &&
        value.listBuyerName.length > 0
      ) {
        const filteredBuyerNames = value.listBuyerName
          .map((buyer: any) => {
            const parts = [];

            if (buyer.name) parts.push(buyer.name);
            if (buyer.telephoneNumber) parts.push(buyer.telephoneNumber);
            if (buyer.attribute1) parts.push(buyer.attribute1);

            return parts.length > 0 ? parts.join(" - ") : null;
          })
          .filter(Boolean); // Loại bỏ giá trị null, undefined, ""

        setListBuyerName(filteredBuyerNames);
      } else {
        setListBuyerName([]); // Nếu không có dữ liệu hợp lệ, đặt về mảng rỗng
      }
    }
  };

  // Hàm nhận vào payType và trả về payAmount
  const getPayAmountByPayType = (payType: string): number | undefined => {
    const payment = dataPayment?.find((p: any) => p.PayType === payType);
    return payment ? payment?.PayAmount : undefined;
  };

  const getCardBank = () => {
    const bankCard = dataPayment?.find((p: any) => p.PayType === "03");
    return bankCard ? bankCard?.Attribute1 : undefined;
  };

  const headerRef = React.useRef<HTMLDivElement>(null);

  const handleSelectProduct = async (
    product: ProductModel,
    index: number,
    modeSearch?: string,
    isReturnProduct?: boolean,
  ) => {
    try {
      if (branchId) {
        const callapiPromotion = await repositoryPos.post<
          MessageResponse<TblItemPromotionModel[]>
        >(`/api/v1/TblItem/item-promotion`, {
          id: product.id,
          price: product?.price || 0,
          branch: branchId,
          groupId: customerCheck?.groupId,
        });

        const discountRate =
          (callapiPromotion?.data &&
            callapiPromotion?.data.length > 0 &&
            callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
              ?.discountPercent) ||
          0;
        const discountAmount =
          (callapiPromotion?.data &&
            callapiPromotion?.data.length > 0 &&
            callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
              ?.discountAmount) ||
          0;

        let idPromote = 0;
        let idPromoteHT = 0;

        if (callapiPromotion?.data) {
          idPromote =
            callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]?.id || 0;
          idPromoteHT =
            callapiPromotion?.data[0]?.tblPromotionItemGift[0]?.id || 0;
        }
        const addData: dataOrderDetailTable = {
          attribute23: product?.wareHouseCode,
          attribute20: product?.warranty?.toString(),
          id: product?.id,
          itemCode: product?.productCode,
          itemName: product?.productName,
          primaryUomCode: product?.unit || "",
          orgId: product?.warehouseId || 0,
          warehouse: product?.warehouse || "",
          priceType: "Giá niêm yết",
          quality: isReturnProduct ? -1 : product?.quantity || 1,
          discountRate: discountRate,
          discountAmount: discountAmount,
          discountAdded: 0,
          priceFinal: discountRate
            ? (product?.price || 0) * 1 * (1 - discountRate / 100)
            : (product?.price || 0) * 1 - (discountAmount || 0) || 0,
          vatRate: 0,
          vatAmount: 0,
          totalLineAmount: discountRate
            ? (product?.price || 0) * 1 * (1 - discountRate / 100)
            : (product?.price || 0) * 1 - (discountAmount || 0) || 0,
          note: product?.notes ?? "",
          lineTyle: modeSearch === "DV" ? "DV" : "HH",
          orderHeaderId: 0,
          deptId: 0,
          itemId: product?.id,
          linkToItemId: 0,
          uomCode: "",
          priceListId: 0,
          priceOnPriceList: product?.price || 0,
          idPromote: idPromote || 0,
          idPromoteList: "",
          linkToLineId: 0,
          printInvoiceCheck: 0,
          promotePostPaid: "",
          promoteClearCheck: 0,
          promoteClearDate: "",
          prometeClearPersionId: 0,
          prometeClearClientId: "",
          clientId: 0,
          workShiftId: 0,
          createBy: 0,
          createDate: "",
          lastUpdateBy: 0,
          lastUpdateDate: "",
          subInvId: product?.warehouseId || 0,
          listIdPromotion: [
            callapiPromotion?.data &&
            callapiPromotion.data.length > 0 &&
            typeof callapiPromotion.data[0].tblPromotion.id === "number"
              ? callapiPromotion.data[0].tblPromotion.id
              : null,
          ].filter((id): id is number => id !== null),
          listIdAddOn: [],
          listIdGift:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemGift &&
              callapiPromotion?.data[0]?.tblPromotionItemGift.map(
                (item) => item.idItemGift,
              )) ||
            [],
          promotionDiscountPercent:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
                ?.discountPercent) ||
            0,
          promotionDiscountAmount:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
                ?.discountAmount) ||
            0,
          promotionItemGift:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemGift.map((item) => ({
                itemCode: item?.itemForSellModel.productCode,
                itemName: item?.itemForSellModel.productName,
                primaryUomCode: item?.itemForSellModel.unit || "",
                quality: 1,
                warehouse: item?.itemForSellModel.warehouse,
              }))) ||
            [],
        };

        if (
          callapiPromotion?.data &&
          callapiPromotion?.data[0]?.tblPromotionItemGift?.length > 0
        ) {
          setListAdd((prevList) => {
            // Nếu index === -1, thêm addData vào đầu mảng
            if (index === -1) {
              return [addData, ...prevList]; // Thêm addData vào đầu, và dataItemGif vào cuối
            } else {
              // Nếu index khác -1, cập nhật phần tử tại vị trí index và thêm dataItemGif
              const newList = [...prevList];
              newList[index] = addData;
              return newList;
            }
          });
          return;
        }

        setListAdd((prevList) => {
          if (index === -1) {
            return [addData, ...prevList];
          } else {
            const newList = [...prevList];
            newList[index] = addData;
            return newList;
          }
        });

        setIsCreating(false);
        table.setEditingRow(null);
        setDataProducts([]);
      }
    } catch (error) {
      console.error("Error in handleSelectProduct:", error);
    }
  };

  const handleGetNameAccountantById = async (
    accountantId: number | undefined,
  ) => {
    try {
      if (accountantId && accountantId != 0) {
        const response = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmEmployee/detail-employee?id=${accountantId}`,
        );
        if (response && response.success) {
          setAccountantName(response?.data?.fullName);
        }
      }
    } catch (error) {
      console.error("Error fetching accountant name:", error);
      return ""; // Trả về chuỗi rỗng nếu có lỗi
    }
  };

  const handleSelectPromotionMain = (promotionMain: any) => {
    const updatedList = listAdd.map((item) => {
      // Kiểm tra nếu itemId trùng với idItemPrimary
      if (
        item?.itemId ===
        promotionMain?.tblPromotionItemPrimary[0]?.idItemPrimary
      ) {
        // Cập nhật logic xử lý ở đây, ví dụ thêm trường mới hoặc thay đổi giá trị
        return {
          ...item,
          discountAmount:
            promotionMain?.tblPromotionItemPrimary[0]?.discountAmount,
          discountRate:
            promotionMain?.tblPromotionItemPrimary[0]?.discountPercent,
          priceFinal: promotionMain?.tblPromotionItemPrimary[0]?.discountPercent
            ? item?.priceOnPriceList *
                1 *
                (1 -
                  promotionMain?.tblPromotionItemPrimary[0]?.discountPercent /
                    100) -
              (item?.discountAdded || 0)
            : item?.priceOnPriceList * 1 -
                (promotionMain?.tblPromotionItemPrimary[0]?.discountAmount ||
                  0) -
                (item?.discountAdded || 0) || 0,
        };
      }
      return item; // Trả về item không thay đổi nếu không khớp
    });
    setListAdd(updatedList);
  };

  const handleSelectProductAddOn = async (
    products: itemAddOnPromotionModel[],
    itemId: string,
  ) => {
    try {
      if (branchId) {
        const newAddDataList: dataOrderDetailTable[] = [];

        for (const product of products) {
          const callapi = await repositoryPos.post<
            MessageResponse<ItemDetailPriceModel>
          >(
            `/api/v1/TblPriceListDetail/detail-price?id=${product?.idItemAddOn}&BranchId=${branchId}`,
          );

          if (callapi?.success) {
            const addData: dataOrderDetailTable = {
              attribute23: product?.itemForSellModel?.wareHouseCode,
              id: product?.idItemAddOn || 0,
              itemCode: product?.itemForSellModel?.productCode || "",
              itemName: product?.itemForSellModel?.productName || "",
              primaryUomCode: product?.itemForSellModel?.unit || "",
              orgId: product?.itemForSellModel?.warehouseId || 0,
              warehouse: product?.itemForSellModel?.warehouse || "",
              priceType: "Giá niêm yết",
              quality: 1,
              discountRate: product.discountPercent || 0,
              discountAmount: product.discountAmount || 0,
              discountAdded: 0,
              priceFinal: product.discountPercent
                ? callapi?.data?.listPrice -
                  (callapi?.data?.listPrice * product.discountPercent) / 100
                : callapi?.data?.listPrice - (product.discountAmount || 0),
              vatRate: callapi.data?.vatRate || 0,
              vatAmount: callapi.data?.vatAmount || 0,
              totalLineAmount: product.discountPercent
                ? callapi?.data?.listPrice -
                  (callapi?.data?.listPrice * product.discountPercent) / 100
                : callapi?.data?.listPrice - (product.discountAmount || 0),
              note: "",
              lineTyle: "HK",
              orderHeaderId: 0,
              deptId: 0,
              itemId: product?.idItemAddOn || 0,
              linkToItemId: Number(itemId),
              uomCode: "",
              priceListId: callapi.data?.idPriceLis || 0,
              priceOnPriceList: callapi.data?.listPrice || 0,
              idPromote: product?.id || 0,
              idPromoteList: "",
              linkToLineId: 0,
              printInvoiceCheck: 0,
              promotePostPaid: "",
              promoteClearCheck: 0,
              promoteClearDate: "",
              prometeClearPersionId: 0,
              prometeClearClientId: "",
              clientId: 0,
              workShiftId: 0,
              createBy: 0,
              createDate: "",
              lastUpdateBy: 0,
              lastUpdateDate: "",
              subInvId: product?.itemForSellModel?.warehouseId || 0,
              listIdPromotion: [],
              listIdAddOn: [],
              listIdGift: [],
              promotionDiscountPercent: 0,
              promotionDiscountAmount: 0,
            };

            newAddDataList.push(addData);
          }
        }

        setListAdd((prevList) => [...prevList, ...newAddDataList]);
        table.setEditingRow(null);
      }
    } catch (error) {
      console.error("Error in handleSelectProductAddOn:", error);
    }
  };

  const handleSelectProductGift = async (
    products: itemGiftPromotionModel[],
    itemId: string,
  ) => {
    try {
      if (branchId) {
        const addDataList: dataOrderDetailTable[] = [];

        for (const product of products) {
          const callapi = await repositoryPos.post<
            MessageResponse<ItemDetailPriceModel>
          >(
            `/api/v1/TblPriceListDetail/detail-price?id=${product?.idItemGift}&BranchId=${branchId}`,
          );

          if (callapi?.success) {
            const addData: dataOrderDetailTable = {
              attribute23: product?.itemForSellModel?.wareHouseCode,
              id: product?.idItemGift || 0,
              itemCode: product?.itemForSellModel?.productCode || "",
              itemName: product?.itemForSellModel?.productName || "",
              primaryUomCode: product?.itemForSellModel?.unit || "",
              orgId: product?.itemForSellModel?.warehouseId || 0,
              warehouse: product?.itemForSellModel?.warehouse || "",
              priceType: "Giá niêm yết",
              quality: 1,
              discountRate: 100,
              discountAmount: 0,
              discountAdded: 0,
              priceFinal: 0,
              vatRate: callapi.data?.vatRate || 0,
              vatAmount: callapi.data?.vatAmount || 0,
              totalLineAmount: 0,
              note: "",
              lineTyle: "KM",
              orderHeaderId: 0,
              deptId: 0,
              itemId: product?.idItemGift || 0,
              linkToItemId: Number(itemId),
              uomCode: "",
              priceListId: callapi.data?.idPriceLis || 0,
              priceOnPriceList: callapi.data?.listPrice || 0,
              idPromote: product?.id || 0,
              idPromoteList: "",
              linkToLineId: 0,
              printInvoiceCheck: 0,
              promotePostPaid: "",
              promoteClearCheck: 0,
              promoteClearDate: "",
              prometeClearPersionId: 0,
              prometeClearClientId: "",
              clientId: 0,
              workShiftId: 0,
              createBy: 0,
              createDate: "",
              lastUpdateBy: 0,
              lastUpdateDate: "",
              subInvId: product?.itemForSellModel?.warehouseId || 0,
              listIdPromotion: [],
              listIdAddOn: [],
              listIdGift: [],
              promotionDiscountPercent: 0,
              promotionDiscountAmount: 0,
            };
            addDataList.push(addData);
          }
        }

        setListAdd((prevList) => [...prevList, ...addDataList]);
      }
    } catch (error) {
      console.error("Error in handleSelectProductGift:", error);
    }
  };

  const checkDebtLimit = (dueAmount: any, debtLimit: any, debtType: string) => {
    if (debtType !== "Công nợ") return true;
    const totalDebt = dueAmount || 0; // Tổng số tiền nợ
    const limit = debtLimit || 0; // Hạn mức công nợ

    if (totalDebt > limit) {
      NotificationExtension.Fails(
        `Đơn Hàng ${
          orderHeader?.orderNumber
        } vượt quá hạn mức công nợ: ${limit.toLocaleString(
          "vi-VN",
        )} VNĐ. Không thể thanh toán.`,
      );
      return false; // Trả về false nếu vượt hạn mức công nợ
    }

    return true; // Trả về true nếu trong hạn mức
  };

  const handleCallApiPayment = async () => {
    try {
      // Kiểm tra công nợ trước khi thực hiện thanh toán
      if (
        !checkDebtLimit(
          deferredPayment - orderHeader?.amountPaid,
          customerCheck?.debtLimit,
          dataPaymentLatter
            ? dataPaymentLatter?.payLaterMethod
            : payLaterMethod,
        )
      ) {
        return; // Dừng nếu công nợ vượt hạn mức
      }

      // Tạo mảng paymentCommands
      const paymentCommands = [
        {
          // Tiền mặt
          payType: "02",
          payAmount: cashPayment,
          payeeId: customerCheck?.id,
        },
        {
          // QR MB
          payType: "01",
          payAmount: bankTransfer,
          payeeId: customerCheck?.id,
          attribute1: selectedBankReserve,
          attribute2: transactionCodeReserve
            ? transactionCodeReserve
            : transactionCodeMb,
        },
        {
          // VN pay
          payType: "04",
          payAmount: vnpayPayment,
          payeeId: customerCheck?.id,
        },
        {
          // Cà thẻ
          payType: "03",
          payAmount: cardPayment,
          payeeId: customerCheck?.id,
          attribute1: selectedBank, // Ngân hàng cà thẻ
        },
        {
          // Thanh toán khác
          payType: "08",
          payAmount: anotherPayment,
          payeeId: customerCheck?.id,
          attribute1: selectedBankReserve,
          attribute2: transactionCodeReserve,
        },
      ].filter((payment) => payment.payAmount > 0); // Lọc các phương thức thanh toán có payAmount > 0

      const combinedInfo = {
        payLaterMethod,
        installmentInfo:
          payLaterMethod === "Trả góp" ? installmentInfo : undefined,
        debtInfo: payLaterMethod === "Công nợ" ? debtInfo : undefined,
      };

      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/payment", {
        paymentCommands: paymentCommands,
        orderNumber: orderHeader?.orderNumber,
        attribute20: JSON.stringify(combinedInfo),
        attribute1: selectedBankReserve,
        attribute2: transactionCodeReserve,
        attribute23: orderHeader?.attribute23 || "",
        tblOrderDetails: dataAllocate?.length > 0 ? listAdd : [],
        orderTotal: payableAmount,
      });

      if (response?.success) {
        setOrderStatus("DON_HANG_HOAN_THANH");
        // Thanh toán thành công update thời gian hoàn thành
        setOrderHeader((prev) => ({
          ...prev,
          orderDate: new Date().toISOString(),
        }));

        setTimeout(
          () => NotificationExtension.Success("Hoàn tất thanh toán thành công"),
          500,
        );

        // setIsPrinting(true);
        // setIdPrint(location?.state.id);
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    }
    modals.closeAll();
  };

  const handleDeleteOrder = async (orderNumber: string, type: string) => {
    const res = await repositoryPos.get<MessageResponse<boolean>>(
      `/api/v1/CreateSellItem/delete?orderNumber=${orderNumber}`,
    );
    if (res?.success) {
      type === "cancel"
        ? NotificationExtension.Success("Hủy thành công !")
        : NotificationExtension.Success("Từ chối duyệt thành công !");
      setOrderStatus("DON_HANG_HUY");
    } else
      type === "cancel"
        ? NotificationExtension.Fails("Hủy thất bại !")
        : NotificationExtension.Fails("Từ chối duyệt thất bại !");
    modals.closeAll();
  };

  const handleCopyItemCodes = () => {
    const itemCodes = listAdd.map((item) => item.itemCode).join("\n"); // Ghép itemCode thành chuỗi
    navigator.clipboard
      .writeText(itemCodes)
      .then(() => {
        NotificationExtension.Success("Đã sao chép mã đơn hàng!");
      })
      .catch((err) => console.error("Lỗi sao chép:", err));
  };

  const handleClickCancelSalesOrder = () => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xác nhận hủy đơn hàng !</Title>
        </>
      ),

      size: "xs",
      children: (
        <Flex justify={"end"} gap={20} mt={"sm"}>
          <Button
            color="gray"
            leftSection={<IconWindow size={18} />}
            onClick={() => {
              modals.closeAll();
            }}
          >
            Huỷ
          </Button>
          <Button
            leftSection={<IconCheck size={18} />}
            onClick={() => {
              handleDeleteOrder(orderHeader?.orderNumber, "cancel");
              navigate("/sell/sales-order-list");
              modals.closeAll();
            }}
          >
            Xác nhận
          </Button>
        </Flex>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleCreateSalesOrder = useDebouncedCallback(
    async (isLock: boolean) => {
      if (
        !handleCheckIsSuccessValidateItem(listAdd) &&
        location?.state?.actionType === "doi"
      ) {
        NotificationExtension.Warn(
          "Vui lòng điền trường hợp đổi , Serial đổi !",
        );
        return;
      }

      // Validate lý do "Đổi/Trả" cho loại DV
      const dvItemsWithoutReason = listAdd.filter(
        (item) => item.lineTyle === "DV" && !item.attribute2,
      );
      if (dvItemsWithoutReason.length > 0) {
        NotificationExtension.Warn(
          "Vui lòng chọn lý do Đổi/Trả cho tất cả các dịch vụ (DV)!",
        );
        return;
      }
      const isShippingRequired = shipping !== "Nhận tại cửa hàng";
      const isMissingDeliveryInfo = [
        dataDeliveryInformation?.customerId,
        dataDeliveryInformation?.telephoneNumber,
        dataDeliveryInformation?.customerProvinceId,
        dataDeliveryInformation?.customerDistrictId,
        dataDeliveryInformation?.customerCommuneId,
        dataDeliveryInformation?.customerAddress,
        dataDeliveryInformation?.deliveryAppointmentTime,
      ].some((field) => !field);

      if (isShippingRequired && isMissingDeliveryInfo) {
        NotificationExtension.Warn("Vui lòng điền đầy đủ thông tin giao hàng!");
        return;
      }

      if (!orderHeader?.custId && !orderHeaderRef?.custId) {
        NotificationExtension.Warn("Chưa có thông tin khách hàng!");
        return;
      }

      let newListAdd: dataOrderDetailTable[];
      if (location?.state?.actionType === "doi") {
        newListAdd = listAdd
          .map((item) => {
            return {
              ...item,
              totalLineAmount: item.priceFinal * item.quality,
            };
          })
          .filter((i) => {
            return (
              i?.attribute11 !== "G" &&
              i?.attribute11 !== "H" &&
              i?.attribute11 !== "T"
            );
          });
      } else {
        newListAdd = listAdd.map((item) => {
          return {
            ...item,
            totalLineAmount: item.priceFinal * item.quality,
            deptId: orderHeader?.deptId,
            attribute35: "",
          };
        });
      }

      openLoading();
      console.log("orderHeader", orderHeader);
      // attach shipping fee into one of orderDetail.totalLineAmount fields
      const shippingFeeForOrder = Number(
        dataDeliveryInformation?.feeShip ?? orderHeader?.attributeValue3 ?? 0,
      );
      //
      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/create-order-return-v2", {
        orderDetail: newListAdd,
        orderHeader: {
          ...orderHeader,
          attribute33: totalReturnFee,
          // attributeValue3 stores net amount customer receives for return (positive number)
          attributeValue3:
            dataDeliveryInformation?.feeShip ??
            orderHeader.attributeValue3 ??
            0,
          shipngType: shipping,
          shipingVendor: shipingVendor,
          invOrgId: branchId ? branchId : 488,
          orgId: branchId ? branchId : 488,
          saleChanelId: saleChanelId ? saleChanelId : 67,
          saleId: employeeSalesId,
          deptId: departmentId,
          printInvoiceCheck: orderHeader?.printInvoiceCheck,
          attribute2: accountantId,
          attribute18: employeeSalesRevenueId,
          contractcode: contractcode,
          orderTypeId: 3,
          branchId: branchId ? branchId : 488,
          amountTotal: payableAmount,
          amountDiscount: totalKMLine,
          amountVat: 0,
          attribute1: JSON.stringify({
            ...dataDeliveryInformation,
            branchId: branchId,
          }),
          createDate: orderHeader?.orderDate,
          orderNumberLink: location?.state?.orderNumberOld,
          attribute8:
            customerCheck?.name && customerCheck?.code
              ? `${customerCheck.name}||${customerCheck.code}`
              : "",
          attribute16: orderHeader?.attribute16 || customerCheck?.attribute1,
          attribute31: customerCheck?.attribute4,
          custId: orderHeader?.custId ? orderHeader?.custId : customerCheck?.id,
          // attribute36: truPhanBo ? 0 : 1,
        },
        isRetun: location?.state?.actionType === "doi",
        isLock: isLock,
      });

      if (response && response.success) {
        setOrderStatus(isLock ? "DON_HANG_CHOT" : "DON_HANG_TAM");

        setTimeout(
          () =>
            NotificationExtension.Success(
              isLock
                ? "Chốt đơn hàng thành công !"
                : "Lưu đơn hàng thành công !",
            ),
          500,
        );

        SocketExtension.SendMessageToTopic<any>({
          topic: CREATEORDERSUCCESS,
          data: "",
        });
      }
      closeLoading();
    },
    1000,
  );

  const handleEditSalesOrder = useDebouncedCallback(async (isLock: boolean) => {
    // Validate lý do "Đổi/Trả" cho loại DV
    const dvItemsWithoutReason = listAdd.filter(
      (item) => item.lineTyle === "DV" && !item.attribute2,
    );
    if (dvItemsWithoutReason.length > 0) {
      NotificationExtension.Warn(
        "Vui lòng chọn lý do Đổi/Trả cho tất cả các dịch vụ (DV)!",
      );
      return;
    }

    const isShippingRequired = shipping !== "Nhận tại cửa hàng";
    const isMissingDeliveryInfo = [
      dataDeliveryInformation?.customerId,
      dataDeliveryInformation?.telephoneNumber,
      dataDeliveryInformation?.customerProvinceId,
      dataDeliveryInformation?.customerDistrictId,
      dataDeliveryInformation?.customerCommuneId,
      dataDeliveryInformation?.customerAddress,
      dataDeliveryInformation?.deliveryAppointmentTime,
    ].some((field) => !field);

    if (isShippingRequired && isMissingDeliveryInfo) {
      NotificationExtension.Warn("Vui lòng điền đầy đủ thông tin giao hàng!");
      return;
    }

    if (!orderHeader.custId) {
      NotificationExtension.Warn("Chưa có thông tin khách hàng!");
      return;
    }

    const newListAdd = listAdd.map((item) => {
      return {
        ...item,
        totalLineAmount: item.priceFinal * item.quality,
        deptId: orderHeader?.deptId,
      };
    });
    openLoading();
    // attach shipping fee into one of orderDetail.totalLineAmount fields for edit
    const shippingFeeForOrderEdit = Number(
      dataDeliveryInformation?.feeShip ?? orderHeader?.attributeValue3 ?? 0,
    );
    if (shippingFeeForOrderEdit && shippingFeeForOrderEdit !== 0) {
      const idxEdit = newListAdd.findIndex(
        (i) => i?.lineTyle !== "KM" && i?.lineTyle !== "DV",
      );
      const attachIdxEdit = idxEdit >= 0 ? idxEdit : 0;
      newListAdd[attachIdxEdit] = {
        ...newListAdd[attachIdxEdit],
        totalLineAmount:
          (Number(newListAdd[attachIdxEdit].totalLineAmount) || 0) +
          shippingFeeForOrderEdit,
      };
    }

    const response = await repositoryPos.post<
      MessageResponse<dataCreateSalesOrder>
    >("/api/v1/CreateSellItem/edit", {
      orderDetail: newListAdd,
      orderHeader: {
        ...orderHeader,
        // attributeValue3: store net received (positive) for returns
        attributeValue3:
          dataDeliveryInformation?.feeShip ?? orderHeader.attributeValue3 ?? 0,
        shipngType: shipping,
        shipingVendor: shipingVendor,
        invOrgId: branchId ? branchId : 488,
        orgId: branchId ? branchId : 488,
        saleChanelId: saleChanelId ? saleChanelId : 67,
        saleId: employeeSalesId,
        deptId: departmentId,
        printInvoiceCheck: orderHeader?.printInvoiceCheck,
        attribute2: accountantId, //Nguyễn Trang Quyên-0009
        attribute18: employeeSalesRevenueId,
        contractcode: contractcode,
        orderTypeId: 3,
        branchId: branchId ? branchId : 488,
        amountTotal: payableAmount,
        amountDiscount: totalKMLine,
        amountVat: 0,
        attribute1: JSON.stringify({
          ...dataDeliveryInformation,
          branchId: branchId,
        }),
        createDate: orderHeader?.orderDate,
        orderNumberLink: location?.state?.orderNumberOld,
        attribute8:
          customerCheck?.name && customerCheck?.code
            ? `${customerCheck.name}||${customerCheck.code}`
            : "",
        attribute16: customerCheck?.attribute1,
        attribute31: customerCheck?.attribute4,
      },
      isLock: isLock,
    });

    if (response && response.success) {
      setOrderStatus(isLock ? "DON_HANG_CHOT" : "DON_HANG_TAM");

      const messageNoti = isLock
        ? "Chốt đơn hàng thành công !"
        : "Lưu đơn hàng thành công !";
      setTimeout(() => NotificationExtension.Success(messageNoti), 500);

      SocketExtension.SendMessageToTopic<any>({
        topic: CREATEORDERSUCCESS,
        data: "",
      });
      closeLoading();
      return true;
    } else {
      setTimeout(
        () => NotificationExtension.Fails("Lưu đơn hàng thất bại !"),
        500,
      );
      closeLoading();
      return false;
    }
  }, 1000);

  //#region render ui
  const TableSelect: React.FC<TableSelectProps> = ({
    dataProducts,
    onSelectProduct,
    rowIndex,
  }: any) => {
    return (
      <Table.ScrollContainer mih={400} mah={600} minWidth={500} type="native">
        <div style={{ overflowY: "auto", height: "500px" }}>
          <Table striped withTableBorder style={{ tableLayout: "fixed" }}>
            <Table.Thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 10,
              }}
            >
              <Table.Tr>
                <Table.Th>Chọn</Table.Th>
                <Table.Th style={{ width: "70px" }}>Mã sản phẩm</Table.Th>
                <Table.Th style={{ width: "200px" }}>
                  Tên sản phẩm
                </Table.Th>{" "}
                {/* Đặt độ rộng cho cột "Tên sản phẩm" */}
                <Table.Th>Giá</Table.Th>
                <Table.Th>ĐVT</Table.Th>
                <Table.Th>Tồn kho</Table.Th>
                <Table.Th>SL chờ xuất</Table.Th>
                <Table.Th>SL khả dụng</Table.Th>
                <Table.Th>Bảo hành</Table.Th>
                <Table.Th>Mã kho</Table.Th>
                <Table.Th>Kho</Table.Th>
              </Table.Tr>
            </Table.Thead>

            {dataProducts?.length > 0 ? (
              <Table.Tbody>
                {dataProducts?.map((product: any, index: any) => (
                  <Table.Tr key={index}>
                    <Table.Td>
                      <Button
                        size="compact-sm"
                        variant="filled"
                        onClick={() => {
                          onSelectProduct(product, rowIndex);
                          table.setCreatingRow(null);
                        }}
                        disabled={
                          handleCheckChooseProduct(product, listAdd) ||
                          product.tons - product.tonao <= 0
                        }
                      >
                        {handleCheckChooseProduct(product, listAdd)
                          ? "Đã chọn"
                          : "Chọn"}
                      </Button>
                    </Table.Td>
                    <Table.Td>{product.productCode}</Table.Td>
                    <Table.Td style={{ width: "200px" }}>
                      {product.productName}
                    </Table.Td>{" "}
                    {/* Đặt độ rộng cho ô "Tên sản phẩm" */}
                    <Table.Td>
                      <NumberFormatter
                        value={product.price}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Table.Td>
                    <Table.Td>{product.unit}</Table.Td>
                    <Table.Td>{product.tons}</Table.Td>
                    <Table.Td>{product.tonao}</Table.Td>
                    <Table.Td>{product.tons - product.tonao}</Table.Td>
                    <Table.Td>{`${product.warranty} tháng`}</Table.Td>
                    <Table.Td>{product.wareHouseCode}</Table.Td>
                    <Table.Td>{product.warehouse}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            ) : (
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Text>Hãy nhập ID hoặc mã sản phẩm!</Text>
              </Box>
            )}
          </Table>
        </div>
      </Table.ScrollContainer>
    );
  };

  const TableSelectDV: React.FC<TableSelectProps> = ({
    dataProducts,
    onSelectProduct,
    rowIndex,
  }: any) => {
    return (
      <Table.ScrollContainer mih={400} mah={600} minWidth={500} type="native">
        <div style={{ overflowY: "auto", height: "500px" }}>
          {/* Table Header (Fixed) */}
          <Table striped withTableBorder style={{ tableLayout: "fixed" }}>
            <Table.Thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 10, // Đảm bảo tiêu đề luôn nằm trên cùng
              }}
            >
              <Table.Tr>
                <Table.Th>Chọn</Table.Th>
                <Table.Th>Mã sản phẩm</Table.Th>
                <Table.Th>Tên sản phẩm</Table.Th>
                <Table.Th>Giá</Table.Th>
                <Table.Th>ĐVT</Table.Th>
              </Table.Tr>
            </Table.Thead>
          </Table>

          {/* Table Body */}
          {dataProducts?.length > 0 ? (
            <Table striped withTableBorder>
              <Table.Tbody>
                {dataProducts?.map((product: any, index: any) => (
                  <Table.Tr key={index}>
                    <Table.Td>
                      <Button
                        size="xs"
                        variant="filled"
                        onClick={() => {
                          onSelectProduct(product, rowIndex);
                          table.setCreatingRow(null);
                        }}
                        disabled={handleCheckChooseProduct(product, listAdd)}
                      >
                        {handleCheckChooseProduct(product, listAdd)
                          ? "Đã chọn"
                          : "Chọn"}
                      </Button>
                    </Table.Td>
                    <Table.Td>{product.productCode}</Table.Td>
                    <Table.Td>{product.productName}</Table.Td>
                    <Table.Td>
                      <NumberFormatter
                        value={product.price}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Table.Td>
                    <Table.Td>{product.unit}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          ) : (
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Text>Hãy nhập ID hoặc mã sản phẩm!</Text>
            </Box>
          )}
        </div>
      </Table.ScrollContainer>
    );
  };

  const handleOnClickPrint = (id: any) => {
    setIsPrinting(true);
    setIdPrint(id);
  };
  const titleSell = () => {
    return (
      <>
        <_breadcrumb></_breadcrumb>
        <Group align="center" p={"0 10 10 10"} justify="space-between">
          <Flex gap={"xs"}>
            <Button
              disabled={orderStatus === "noCreate"}
              color={"blue"}
              size="xs"
              style={{
                pointerEvents: "auto",
              }}
              onClick={() => {
                navigate("/sell/return-order-v2");
                window.location.reload();
              }}
            >
              Tạo mới
            </Button>
            <Tooltip
              label={isCollapse ? "Mở rộng" : "Thu gọn"}
              position="bottom"
            >
              <Group align="center">
                <Switch
                  size="sm"
                  color={isCollapse ? "red" : "green"}
                  checked={!isCollapse}
                  onChange={toggleCollapse}
                  label={isCollapse ? "Thu gọn (Ctrl+M)" : "Mở rộng (Ctrl+M)"}
                  thumbIcon={
                    !isCollapse ? (
                      <IconMaximize
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    ) : (
                      <IconMaximizeOff
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    )
                  }
                />
              </Group>
            </Tooltip>
          </Flex>
          <Flex
            gap="md"
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <OrderStatus status={orderStatus || "noCreate"}></OrderStatus>
          </Flex>
          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            wrap="wrap"
            align="center"
            direction="row"
          >
            {orderStatus === "DON_HANG_HOAN_THANH" &&
            // !location?.state?.isReadOnly ? (
            true ? (
              <>
                <Button
                  leftSection={<IconPrinter size={20} />}
                  variant="outline"
                  color="indigo"
                  style={{
                    cursor: "pointer",
                    pointerEvents: "auto",
                  }}
                  size="xs"
                  onClick={() => handleOnClickPrint(location?.state?.id)}
                >
                  In hóa đơn
                </Button>
              </>
            ) : (
              <></>
            )}
            <TextInput
              placeholder="Nhập mã đơn hàng trả cả đơn"
              size="xs"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
              onKeyDown={(e) => handleEnterPressAll(e)} // Xử lý sự kiện nhấn phím
              style={{ minWidth: "170px" }}
            />

            {/* <Group align="center">
              <Switch
                size="sm"
                color={isCollapse ? "red" : "green"}
                checked={truPhanBo}
                onChange={(e) => {
                  setTruPhanBo(!truPhanBo);
                }}
                label={"Trừ phân bổ"}
                thumbIcon={
                  truPhanBo ? (
                    <IconMaximize
                      style={{ width: 16, height: 16 }}
                      stroke={2.5}
                      color="white"
                    />
                  ) : (
                    <IconMaximizeOff
                      style={{ width: 16, height: 16 }}
                      stroke={2.5}
                      color="white"
                    />
                  )
                }
              />
            </Group>
            <Button
              disabled={
                location?.state?.actionType === "view" ||
                location?.state?.actionType === "approved" ||
                location?.state?.actionType === "payment" ||
                orderStatus === "DON_HANG_CHOT"
              }
              leftSection={<IconPlus size={14} />}
              variant="outline"
              color="blue"
              size="xs"
              onClick={() => {
                setModeSearch("SP");
                setDataProducts([]);
                table.setCreatingRow(true);
                setIsCreating(true);
              }}
            >
              Thêm sản phẩm
            </Button>
            <Button
              disabled={
                location?.state?.actionType === "view" ||
                location?.state?.actionType === "approved" ||
                location?.state?.actionType === "payment" ||
                orderStatus === "DON_HANG_CHOT"
              }
              leftSection={<IconPlus size={14} />}
              variant="outline"
              color="blue"
              size="xs"
              onClick={() => {
                setIsReturnProduct(false);
                setModeSearch("DV");
                setDataProducts([]);
                table.setCreatingRow(true);
                setIsCreating(true);
              }}
            >
              Thêm dịch vụ
            </Button>
            <Button
              disabled={
                location?.state?.actionType === "view" ||
                location?.state?.actionType === "approved" ||
                location?.state?.actionType === "payment" ||
                orderStatus === "DON_HANG_CHOT"
              }
              leftSection={<IconMinus size={14} />}
              variant="outline"
              color="#FA5252"
              size="xs"
              onClick={() => {
                setIsReturnProduct(true);
                setModeSearch("DV");
                setDataProducts([]);
                table.setCreatingRow(true);
                setIsCreating(true);
              }}
            >
              Trả dịch vụ
            </Button>
            <Flex>
              <TextInput
                placeholder="Nhập mã serial sp cần trả"
                size="xs"
                value={serialNumber}
                onChange={(e) => setSerialNumber(e.target.value)}
                onKeyDown={handleEnterPress} // Xử lý sự kiện nhấn phím
                style={{ minWidth: "170px" }}
              />
              <Button
                style={{ marginLeft: "8px" }}
                size="xs"
                variant="outline"
                color="green"
                onClick={() => setIsModalOpen(true)}
              >
                Nhập SP hệ thống cũ
              </Button>
            </Flex> */}
            <Button
              disabled={
                location?.state?.actionType === "view" ||
                location?.state?.actionType === "approved" ||
                location?.state?.actionType === "payment" ||
                orderStatus === "DON_HANG_CHOT"
              }
              leftSection={<IconMinus size={14} />}
              variant="outline"
              color="#FA5252"
              size="xs"
              onClick={() => {
                setIsReturnProduct(true);
                setModeSearch("DV");
                setDataProducts([]);
                table.setCreatingRow(true);
                setIsCreating(true);
              }}
            >
              Trả dịch vụ
            </Button>
            <Box
              style={{
                ...getStyle(),
              }}
            >
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <ActionIcon
                    style={{
                      pointerEvents:
                        orderStatus === "DON_HANG_HOAN_THANH" ? "none" : "auto",
                    }}
                    disabled={
                      location?.state?.actionType === "view" ||
                      location?.state?.actionType === "approved" ||
                      location?.state?.actionType === "payment"
                    }
                    size="md"
                    variant="outline"
                    color="blue"
                  >
                    <IconMenu2 style={{ width: rem(18), height: rem(18) }} />
                  </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Label>Chức năng</Menu.Label>

                  <Menu.Item>
                    <Button
                      disabled={
                        orderStatus !== "DON_HANG_TAM" &&
                        orderStatus !== "DON_HANG_CHOT"
                      }
                      color={"red"}
                      size="xs"
                      onClick={() => handleClickCancelSalesOrder()}
                    >
                      Hủy đơn
                    </Button>
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      color={"blue"}
                      size="xs"
                      onClick={() => handleCopyItemCodes()}
                    >
                      copy mã hàng
                    </Button>
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Box>

            <Modal
              opened={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              title="Nhập thông tin sản phẩm hệ thống cũ"
            >
              <Flex direction="column" gap="sm">
                <TextInput
                  label="Mã sản phẩm(SKU)"
                  placeholder="Nhập mã sản phẩm"
                  value={oldProduct.itemCode}
                  onChange={(e) =>
                    setOldProduct({ ...oldProduct, itemCode: e.target.value })
                  }
                />
                <TextInput
                  label="Serial"
                  placeholder="Nhập mã serial"
                  value={oldProduct.attribute13}
                  onChange={(e) =>
                    setOldProduct({
                      ...oldProduct,
                      attribute13: e.target.value.trim(),
                    })
                  }
                />
                <TextInput
                  type="number"
                  label="Giá bán"
                  placeholder="Nhập giá bán"
                  value={oldProduct.priceOnPriceList}
                  onChange={(e) =>
                    setOldProduct({
                      ...oldProduct,
                      priceOnPriceList: e.target.value,
                    })
                  }
                />
                <Button
                  color="blue"
                  onClick={async () => {
                    try {
                      const keySearch = oldProduct.itemCode.toLowerCase(); // Lấy giá trị SKU từ ô nhập
                      const url = `/api/v1/TblItem/get-list?Ship=0&Take=30&KeySearch=${keySearch}`;

                      // Gọi API
                      const searchResult =
                        await repositoryPos.get<
                          MessageResponse<ProductModel[]>
                        >(url);

                      // Xử lý kết quả
                      if (searchResult?.data && searchResult.data.length > 0) {
                        const allMatch = searchResult.data.every(
                          (product) =>
                            product.productCode === oldProduct.itemCode,
                        );

                        if (
                          searchResult.data.length === 1 || // Có 1 phần tử trong mảng
                          allMatch // Hoặc tất cả phần tử đều có productCode === SKU
                        ) {
                          handleAddOldProduct(
                            searchResult.data[0],
                            oldProduct.priceOnPriceList,
                            oldProduct?.attribute13,
                          ); // Thêm sản phẩm đầu tiên
                        } else {
                          NotificationExtension.Warn(
                            "Không tìm thấy sản phẩm phù hợp !",
                          );
                        }
                      } else {
                        NotificationExtension.Warn(
                          "Không tìm thấy sản phẩm phù hợp !",
                        );
                      }
                    } catch (error) {
                      console.error("Error fetching data:", error);
                      alert("Đã xảy ra lỗi khi tìm kiếm sản phẩm.");
                    }

                    // Đóng modal
                    setIsModalOpen(false);
                  }}
                >
                  Thêm sản phẩm trả
                </Button>
              </Flex>
            </Modal>
          </Flex>
        </Group>
      </>
    );
  };

  function getStyle(includePayment = false): CSSProperties {
    const isDisabled =
      location?.state?.actionType === "view" ||
      location?.state?.actionType === "approved" ||
      orderStatus === "DON_HANG_HOAN_THANH" ||
      (includePayment && location?.state?.actionType === "payment") ||
      (orderStatus === "DON_HANG_CHOT" &&
        location?.state?.actionType !== "payment");

    return {
      opacity: isDisabled ? 0.9 : 1,
      pointerEvents: isDisabled ? "none" : "auto",
    };
  }

  console.log(
    "customerCheck12121212",
    saleChanelList,
    orderHeader?.saleChanelId,
    saleChanelList?.find(
      (s: any) => Number(s.id) === Number(orderHeader?.saleChanelId),
    )?.name,
  );

  const formOrderHeader = () => {
    return (
      <Box
        style={{
          padding: 5,
          height: "100%",
          position: "relative",
          ...getStyle(),
        }}
      >
        <Box
          style={{
            ...getStyle(true),
          }}
        >
          <Grid>
            <Grid.Col span={6}>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Mã đơn hàng:<span style={{ color: "red" }}>*</span>
                </Text>
                <Text fw={500}>{orderHeader?.orderNumber}</Text>
              </Flex>
              {(location?.state?.orderNumberOld ||
                orderHeader?.orderNumberLink) && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>
                    Mã ĐH cũ:<span style={{ color: "red" }}>*</span>
                  </Text>
                  <Text fw={500}>
                    {orderHeader?.orderNumberLink
                      ? orderHeader?.orderNumberLink
                      : location?.state?.orderNumberOld}
                  </Text>
                </Flex>
              )}
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Chi nhánh:"
                  value={branchName}
                  options={handleGetNameBranch(listBranch) || []}
                  onChange={(value: any) => {
                    setBranchName(value);
                    const BranchId = listBranch.find((item) => {
                      return item.text == value;
                    });
                    setBranchId(Number(BranchId?.value));
                    setListAdd([]);
                    setDataProducts([]);
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  readOnly
                  required
                  label="Bộ phận:"
                  value={department}
                  options={handleGetNameDepartment(listDepartment)}
                  onChange={(value) => {
                    setDepartment(value);
                    const departmentId = listDepartment?.find((item) => {
                      return item?.name === value;
                    });
                    setDepartmentId(departmentId?.departmentId);
                  }}
                  width="280px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  readOnly
                  required
                  label="NV tạo đơn:"
                  value={employeeSalesName}
                  options={[]}
                  onChange={(value: any) => {
                    alert("");
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  readOnly
                  required
                  label="NV hưởng số:"
                  value={employeeSalesRevenueName}
                  options={handleGetNameEmployeeAll(listEmployeeSales) || []}
                  onChange={(value: any) => {
                    setEmployeeSalesRevenueName(value);
                    const saleRevenueId = listEmployeeSales.find((item) => {
                      return `${item?.fullname} - ${item?.code}` === value;
                    });
                    setEmployeeSalesRevenueId(saleRevenueId?.id);
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Mã ĐTCN:</Text>
                <Box style={{ position: "relative", maxWidth: "200px" }}>
                  <Tooltip
                    label={
                      orderHeader?.attribute16 || customerCheck?.attribute1
                    }
                    disabled={
                      !orderHeader?.attribute16 && !customerCheck?.attribute1
                    }
                  >
                    <Text fw={500} truncate>
                      {orderHeader?.attribute16 ||
                        customerCheck?.attribute1 ||
                        "Tìm mã ĐTCN"}
                    </Text>
                  </Tooltip>
                  {/* <IconSearch
                    size={20}
                    style={{
                      position: "absolute",
                      right: -30,
                      top: 0,
                      cursor: "pointer",
                      color: cobalt_blue.base,
                    }}
                    onClick={() => openFormCustomer(true)}
                  /> */}
                </Box>
              </Flex>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Khách hàng:<span style={{ color: "red" }}>*</span>
                </Text>
                <Box style={{ position: "relative", maxWidth: "200px" }}>
                  <Tooltip
                    label={customerCheck?.name}
                    disabled={!customerCheck?.name}
                  >
                    <Text fw={500} truncate>
                      {customerCheck?.type === 1
                        ? customerCheck?.name || "Tìm khách hàng"
                        : customerCheck?.companyName || "Tìm khách hàng"}
                    </Text>
                  </Tooltip>
                  {/* <IconSearch
                    size={20}
                    style={{
                      position: "absolute",
                      right: -30,
                      top: 0,
                      cursor: "pointer",
                      color: cobalt_blue.base,
                    }}
                    onClick={() => openFormCustomer(false)}
                  /> */}
                </Box>
              </Flex>
              {(listBuyerName?.length > 0 || orderHeader?.attribute36) && (
                <Flex align="center" gap="xs">
                  <EditableTextWithOptions
                    required
                    label="Người MH:"
                    value={orderHeader?.attribute36 || ""}
                    options={listBuyerName}
                    onChange={(value: any) => {
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute36: value,
                      }));
                    }}
                    width="250px"
                  />
                </Flex>
              )}
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Số điện thoại:<span style={{ color: "red" }}>*</span>
                </Text>
                <Text style={{ flex: "0 0 100px", fontWeight: "500" }}>
                  {customerCheck?.telephoneNumber}
                </Text>
                <CustomerDetail
                  customerCheck={customerCheck}
                  attribute36={orderHeader?.attribute36}
                  orderType={2}
                ></CustomerDetail>
              </Flex>
            </Grid.Col>
            <Grid.Col span={6}>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Thời gian tạo:</Text>
                <Text fw={500}>
                  {formatDateString(orderHeader?.createDate)}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Thời gian HT:</Text>
                <Text fw={500}>
                  {formatDateString(formatOrderDate(orderHeader?.orderDate))}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Kênh bán:"
                  value={
                    saleChanelList
                      ? saleChanelList.find(
                          (s: any) =>
                            Number(s.id) === Number(orderHeader?.saleChanelId),
                        )?.name || saleChanel
                      : saleChanel
                  }
                  options={handlerRenderOptionSelect(saleChanelList)}
                  onChange={(value) => {
                    const selected = saleChanelList?.find(
                      (s: any) => s.name === value,
                    );
                    if (selected) {
                      setSaleChanelId(selected.id);
                      setSaleChanel(selected.name);
                      setOrderHeader((prev) => ({
                        ...prev,
                        saleChanelId: selected.id,
                      }));
                    } else {
                      // if user types a custom value or the list is not loaded
                      setSaleChanel(value as string);
                      setSaleChanelId(undefined);
                      setOrderHeader((prev) => ({ ...prev, saleChanelId: 0 }));
                    }
                  }}
                  width="280px"
                />
              </Flex>
              {location?.state?.actionType === "payment" && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>Thu ngân:</Text>
                  <Text fw={500}>{userLogin?.fullname}</Text>
                </Flex>
              )}
              {location?.state?.actionType === "view" &&
                orderHeader?.orderStatus === "DON_HANG_HOAN_THANH" && (
                  <Flex align="center" gap="xs">
                    <Text style={{ flex: "0 0 100px" }}>Thu ngân:</Text>
                    <Text fw={500}>{accountantName}</Text>
                  </Flex>
                )}
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Loại KH:<span style={{ color: "red" }}>*</span>
                </Text>
                <Text fw={500}>
                  {customerCheck?.type
                    ? customerCheck?.type === 1
                      ? "Khách lẻ"
                      : "Khách doanh nghiệp"
                    : ""}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Thông tin HĐ:"
                  popoverLabel="Chọn thông tin HĐ:"
                  value={
                    (orderHeader?.printInvoiceCheck ?? 0) === 0
                      ? "Không"
                      : orderHeader?.printInvoiceCheck === 1
                        ? "Có"
                        : "Nợ"
                  }
                  options={["Không", "Có", "Nợ"]}
                  optionLabels={{
                    Không: "KH tiêu dùng – HĐ khách lẻ",
                    Có: "Có lấy hóa đơn",
                    Nợ: "Nợ hóa đơn",
                  }}
                  onChange={(e) => {
                    setOrderHeader((prev) => ({
                      ...prev,
                      printInvoiceCheck:
                        e === "Không"
                          ? 0
                          : e === "Có"
                            ? 1
                            : e === "Nợ"
                              ? 2
                              : prev.printInvoiceCheck,
                    }));
                  }}
                />
              </Flex>
              {orderHeader?.attribute27 && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>Số VAT cũ:</Text>
                  <Text style={{ flex: "0 0 100px" }}>
                    {orderHeader?.attribute27}
                  </Text>
                </Flex>
              )}
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Yêu cầu DV:"
                  value={handleGetTechnicialRequireName(
                    orderHeader?.technicalRequired ?? 0,
                  )}
                  options={[
                    "Không",
                    "Lắp ráp(mới)",
                    "Kiểm tra(mới)",
                    "Lắp ráp(mới) + Kiểm tra(mới)",
                  ]}
                  onChange={(e) =>
                    setOrderHeader((prev) => ({
                      ...prev,
                      technicalRequired: handleGetTechnicialRequireId(e) ?? 0,
                    }))
                  }
                />
              </Flex>
              <Flex>
                <SelectBuildPc
                  value={parseAttribute19(orderHeader?.attribute19)}
                  onChange={(data) => {
                    const updatedAttribute19 = JSON.stringify({
                      machineCode: data.machineCode,
                      quantity: data.quantity,
                    });
                    setOrderHeader((prev) => ({
                      ...prev,
                      attribute19: updatedAttribute19,
                    }));
                  }}
                  required
                  label="Build Pc"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <SelectPaymentMethod
                  customerCheck={customerCheck}
                  required
                  width="230px"
                  label="PT thanh toán:"
                  value={orderHeader?.attribute24 || "Thu Tiền Ngay"}
                  shipping={shipping}
                  options={[
                    "Thu Tiền Ngay",
                    "Thu tiền sau lắp đặt",
                    "Giao Hàng Thu Tiền(COD)",
                    "Đã chuyển khoản",
                    "Trả góp",
                    "Đối Trừ Công Nợ",
                    "Công nợ nội bộ",
                    "Công Nợ 3 Ngày",
                    "Công Nợ 4 Ngày",
                    "Công Nợ 5 Ngày",
                    "Công Nợ 7 Ngày",
                    "Công Nợ 10 Ngày",
                    "Công Nợ 15 Ngày",
                    "Công Nợ 20 Ngày",
                    "Công Nợ 21 Ngày",
                    "Công Nợ 30 Ngày",
                  ]}
                  onChange={(e) =>
                    setOrderHeader((prev) => ({
                      ...prev,
                      attribute24: e ?? "",
                    }))
                  }
                />
              </Flex>
              <Flex align="center" gap="xs" mt={-4}>
                <Text style={{ flex: "0 0 100px" }}>Mã hợp đồng:</Text>
                <TextInput
                  value={contractcode}
                  onChange={(e) => setContractcode(e.target.value)}
                  variant="unstyled"
                  size="md"
                  fs={"14px"}
                  fw={"500"}
                  placeholder="Nhập mã đợp đồng"
                />
              </Flex>
            </Grid.Col>
          </Grid>
          <Divider my="sm" mt={0} />
          <Grid mt={10}>
            <Grid.Col span={6}>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Giao hàng:"
                  value={shipping}
                  options={["Nhận tại cửa hàng", "Giao hàng"]}
                  onChange={(val) => {
                    setShipping(val);
                    if (
                      val === "Nhận tại cửa hàng" &&
                      (orderHeader?.attribute24 === "Giao Hàng Thu Tiền(COD)" ||
                        orderHeader?.attribute24?.toLowerCase()?.includes("giao hàng thu tiền"))
                    ) {
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute24: "Thu Tiền Ngay",
                      }));
                      NotificationExtension.Warn(
                        "Đã tự động chuyển PT thanh toán về 'Thu Tiền Ngay' do nhận tại cửa hàng!",
                      );
                    }
                  }}
                />
              </Flex>
            </Grid.Col>
            <Grid.Col span={6}>
              <Grid>
                {(shipping === "Nội bộ" ||
                  shipping === "Đối tác vận chuyển" ||
                  shipping === "Giao hàng") && (
                  <Grid.Col span={6}>
                    <Flex>
                      <Text style={{ flex: "0 0 57px" }}>
                        Chi tiết: <span style={{ color: "red" }}>*</span>
                      </Text>
                      <Button
                        style={{
                          pointerEvents:
                            location?.state?.actionType === "payment" ||
                            location?.state?.actionType === "approved"
                              ? "none"
                              : "auto",
                        }}
                        ml={10}
                        size="xs"
                        onClick={() => {
                          if (listAdd.length > 0) {
                            if (shipingVendor || true) {
                              openModalDeliveryInformation();
                            } else {
                              NotificationExtension.Warn(
                                "Chưa chọn đơn vị tiếp nhận !",
                              );
                            }
                          } else {
                            NotificationExtension.Warn(
                              "Chưa có sản phẩm trong đơn !",
                            );
                          }
                        }}
                        variant="transparent"
                      >
                        <IconTruck size={22} /> {/* Biểu tượng xe tải */}
                      </Button>
                    </Flex>
                  </Grid.Col>
                )}
              </Grid>
            </Grid.Col>
          </Grid>
        </Box>
        <Divider my={"sm"} />
        {/* {!location?.state?.isReadOnly && ( */}
        {true && (
          <Box>
            {/* <Grid>
              <Grid.Col span={12} pt={0} pb={0} mt={-4}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>
                    Xin giảm trên tổng đơn:
                  </Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={
                      totalXGDetail > 0 ||
                      location?.state?.actionType === "payment" ||
                      location?.state?.actionType === "view" ||
                      location?.state?.actionType === "approved" ||
                      listAdd.length === 0
                        ? true
                        : false
                    }
                    variant="unstyled"
                    autoFocus
                    style={{ height: 38 }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền"}
                    hideControls
                    value={orderHeader?.discountAddedTotal || ""}
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) =>
                      setOrderHeader({
                        ...orderHeader,
                        discountAddedTotal: Number(e),
                      })
                    }
                    clampBehavior="strict"
                    min={1}
                    max={1000000000}
                    allowDecimal={false}
                    allowNegative={false}
                  />
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>
                    Khuyến mãi tổng đơn:
                  </Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={
                      location?.state?.actionType === "payment" ||
                      location?.state?.actionType === "view" ||
                      location?.state?.actionType === "approved" ||
                      listAdd.length === 0
                        ? true
                        : false
                    }
                    variant="unstyled"
                    style={{ height: 38 }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền khuyến mãi"}
                    hideControls
                    value={orderHeader?.amountDiscountTotal || ""}
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) =>
                      setOrderHeader({
                        ...orderHeader,
                        amountDiscountTotal: Number(e),
                      })
                    }
                    clampBehavior="strict"
                    min={1}
                    max={1000000000}
                    allowDecimal={false}
                    allowNegative={false}
                  />
                </Flex>
              </Grid.Col>
            </Grid>
            <Divider my="sm" /> */}
            <Grid>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tổng tiền hàng:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={totalAmount}
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tổng giảm trừ:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={
                        (totalKM +
                          (totalXGDetail ?? 0) +
                          (orderHeader?.discountAddedTotal ?? 0) || 0) === 0
                          ? 0
                          : `-${
                              totalKM +
                                (totalXGDetail ?? 0) +
                                (orderHeader?.discountAddedTotal ?? 0) || 0
                            }`
                      }
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tổng phí đổi trả:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={Math.floor(totalReturnFee)}
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tổng phí ship:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={Number(
                        dataDeliveryInformation?.feeShip ??
                          orderHeader.attributeValue3 ??
                          0,
                      )}
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              {totalPhanBo > 0 && (
                <Grid.Col span={12} pt={0} pb={0}>
                  <Flex align="center" gap="xs">
                    <Text style={{ flex: "0 0 150px" }}>
                      Tổng tiền trừ phân bổ:
                    </Text>
                    <Text fw={500} style={{ width: "25%" }}></Text>
                    <Text fw={"500"}>
                      <NumberFormatter
                        value={Math.floor(totalPhanBo)}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Text>
                  </Flex>
                </Grid.Col>
              )}
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>
                    Số tiền cần thanh toán:
                  </Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"} style={{ color: "red" }}>
                    <NumberFormatter
                      style={{ fontSize: "17px" }}
                      value={Math.floor(
                        location?.state?.actionType === "view"
                          ? orderHeader?.amountTotal
                          : payableAmount - orderHeader?.amountPaid,
                      )}
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                    {` (Đã VAT) `}
                  </Text>
                </Flex>
              </Grid.Col>
            </Grid>
            <Divider my={"sm"} />
            <Grid>
              <Grid.Col span={12} pt={0} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs" style={{ pointerEvents: "auto" }}>
                  <Text fs={"16px"} fw={"500"} style={{ flex: "0 0 150px" }}>
                    Thanh toán trước:
                  </Text>
                  {location?.state?.actionType === "view" &&
                    orderHeader?.orderStatus === "DON_HANG_HOAN_THANH" && (
                      <>
                        <Text fw={500} style={{ width: "25%" }}></Text>
                        <PaymentDetails
                          orderNumber={orderHeader?.orderNumber}
                        ></PaymentDetails>
                      </>
                    )}
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} mt={-12} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tiền mặt:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={
                      location?.state?.actionType !== "payment" ||
                      payableAmount <= 0
                    }
                    variant="unstyled"
                    autoFocus
                    style={{ height: 32 }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền"}
                    hideControls
                    value={
                      dataPayment
                        ? getPayAmountByPayType("02")
                        : cashPayment || ""
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) => handleChangePrice(e, "cashPayment")}
                    clampBehavior="strict"
                    min={1}
                    max={1000000000000}
                    allowNegative={false}
                    allowDecimal={false}
                  />
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Chuyển khoản:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={
                      location?.state?.actionType !== "payment" ||
                      payableAmount <= 0
                    }
                    variant="unstyled"
                    autoFocus
                    style={{ height: 32 }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền"}
                    hideControls
                    value={
                      dataPayment
                        ? getPayAmountByPayType("01")
                        : bankTransfer || ""
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) => handleChangePrice(e, "bankTransfer")}
                    min={1}
                    max={10000000000}
                    clampBehavior="strict"
                    allowNegative={false}
                    allowDecimal={false}
                  />
                  {!(
                    location?.state?.actionType == "approved" ||
                    location?.state?.actionType !== "payment"
                  ) &&
                    bankTransfer && (
                      <IconCreditCard
                        style={{
                          cursor: "pointer",
                          color: cobalt_blue.base, // Adjust color if needed
                        }}
                        onClick={() =>
                          openModalPaymentMb(bankTransfer, anotherPayment)
                        }
                      />
                    )}
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>CK khác:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={
                      location?.state?.actionType !== "payment" ||
                      payableAmount <= 0
                    }
                    variant="unstyled"
                    autoFocus
                    style={{ height: 32 }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền"}
                    hideControls
                    value={
                      dataPayment
                        ? getPayAmountByPayType("08")
                        : anotherPayment || ""
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) => handleChangePrice(e, "anotherPayment")}
                    min={1}
                    max={10000000000}
                    clampBehavior="strict"
                    allowNegative={false}
                    allowDecimal={false}
                  />
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs" direction="column">
                  <Flex align="center" gap="xs" style={{ width: "100%" }}>
                    <Text style={{ flex: "0 0 150px" }}>Thanh toán thẻ:</Text>
                    <Text fw={500} style={{ width: "25%" }}></Text>
                    <NumberInput
                      disabled={
                        location?.state?.actionType !== "payment" ||
                        payableAmount <= 0
                      }
                      variant="unstyled"
                      autoFocus
                      style={{ height: 32 }}
                      size="md"
                      fw={"500"}
                      placeholder={"Nhập số tiền"}
                      hideControls
                      value={
                        dataPayment
                          ? getPayAmountByPayType("03")
                          : cardPayment || ""
                      }
                      thousandSeparator="."
                      decimalSeparator=","
                      onChange={(value) =>
                        handleChangePrice(value, "cardPayment")
                      }
                      min={1}
                      max={10000000000}
                      clampBehavior="strict"
                      allowNegative={false}
                      allowDecimal={false}
                    />
                    {(dataPayment
                      ? getPayAmountByPayType("03")
                      : false || cardPayment != 0) && (
                      <Select
                        placeholder="Chọn ngân hàng"
                        data={bankOptions}
                        value={dataPayment ? getCardBank() : selectedBank || ""}
                        onChange={(e) => setSelectedBank(e || "")}
                        style={{ width: "25%" }}
                        disabled={location?.state?.actionType !== "payment"}
                      />
                    )}
                  </Flex>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tổng:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={totalPaid || 0}
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <>
                <Grid.Col span={12} py={0} h={"fit-content"}>
                  <Flex align="center" gap="xs">
                    <Text style={{ flex: "0 0 150px", fontWeight: "500" }}>
                      Thanh toán sau:
                    </Text>
                    <Box
                      style={{
                        width: "25%",
                        pointerEvents:
                          location?.state?.actionType === "payment" &&
                          orderStatus !== "DON_HANG_HOAN_THANH"
                            ? "auto"
                            : "none",
                      }}
                    >
                      {/* <EditableTextWithOptions
                        isCod
                        label=""
                        value={
                          dataPaymentLatter
                            ? dataPaymentLatter?.payLaterMethod
                            : payLaterMethod
                        }
                        options={["Không", "COD", "Công nợ", "Trả góp"]}
                        onChange={setPayLaterMethod}
                      /> */}
                    </Box>
                    <Text fw={"500"} style={{ color: "red" }}>
                      <NumberFormatter
                        style={{ fontSize: "17px" }}
                        value={Math.floor(
                          location?.state?.actionType === "view"
                            ? orderHeader?.amountRemaining
                            : deferredPayment - orderHeader?.amountPaid,
                        )}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Text>
                    {/* Nút bấm hiển thị modal nếu điều kiện phù hợp */}
                    {/* {payLaterMethod === "Công nợ" && (
                      <Button
                        size="xs"
                        onClick={() => handleOpenModal("Công nợ")}
                        style={{
                          marginLeft: "10px",
                          pointerEvents:
                            location?.state?.actionType === "view" ||
                            location?.state?.actionType === "payment"
                              ? "auto"
                              : "none",
                        }}
                      >
                        Nhập công nợ
                      </Button>
                    )} */}
                    {payLaterMethod === "Trả góp" && (
                      <Button
                        size="xs"
                        onClick={() => handleOpenModal("Trả góp")}
                        style={{
                          marginLeft: "10px",
                          pointerEvents:
                            location?.state?.actionType === "view" ||
                            location?.state?.actionType === "payment"
                              ? "auto"
                              : "none",
                        }}
                      >
                        Nhập trả góp
                      </Button>
                    )}
                  </Flex>
                </Grid.Col>

                {/* Modal Công nợ */}
                <Modal
                  style={{
                    pointerEvents:
                      location?.state?.actionType === "payment" &&
                      orderStatus !== "DON_HANG_HOAN_THANH"
                        ? "auto"
                        : "none",
                  }}
                  opened={modalType === "Công nợ"}
                  onClose={handleCloseModal}
                  title="Nhập thông tin Công nợ"
                  centered
                >
                  {/* Hiển thị thông báo thời hạn công nợ mặc định */}
                  <Text size="sm" color="dimmed" mb="sm" mt={10}>
                    Thời hạn công nợ là{" "}
                    <strong>{customerCheck?.debtTerm || 0}</strong> ngày. Tối đa
                    có thể nhập là{" "}
                    <strong>{(customerCheck?.debtTerm || 0) * 2}</strong> ngày.
                  </Text>

                  {/* Hiển thị hạn mức công nợ với dấu chấm ngăn cách */}
                  <Text size="sm" color="dimmed" mb="sm">
                    Hạn mức công nợ:
                    <strong>
                      {(customerCheck?.debtLimit || 0).toLocaleString("vi-VN")}{" "}
                      VNĐ
                    </strong>
                  </Text>

                  <TextInput
                    label="Thời hạn công nợ"
                    placeholder={`Nhập thời hạn (tối đa ${
                      (customerCheck?.debtTerm || 0) * 2
                    } ngày)`}
                    withAsterisk
                    type="number"
                    value={
                      dataPaymentLatter
                        ? dataPaymentLatter?.debtInfo?.dueDate
                        : debtInfo.dueDate || ""
                    }
                    onChange={(e) => {
                      const newValue = e.target.value; // Lấy giá trị nhập vào
                      const numericValue = parseInt(newValue, 10);

                      // Cho phép giá trị rỗng hoặc số hợp lệ
                      if (
                        newValue === "" ||
                        (numericValue > 0 &&
                          numericValue <= (customerCheck?.debtTerm || 0) * 2)
                      ) {
                        setDebtInfo({ ...debtInfo, dueDate: newValue });
                      }
                    }}
                    onKeyDown={(e) => {
                      // Chặn nhập dấu '-' và ký tự 'e'
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "-" ||
                        e.key === "+"
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />

                  <Flex
                    justify="end"
                    mt="lg"
                    style={{
                      pointerEvents:
                        location?.state?.actionType === "payment" &&
                        orderStatus !== "DON_HANG_HOAN_THANH"
                          ? "auto"
                          : "none",
                    }}
                  >
                    <Button onClick={handleCloseModal} color="gray" mr="sm">
                      Hủy
                    </Button>
                    <Button
                      onClick={() => {
                        if (
                          debtInfo.dueDate === "" ||
                          parseInt(debtInfo.dueDate, 10) === 0
                        ) {
                          // Nếu giá trị nhập không hợp lệ (rỗng hoặc 0), có thể xử lý tại đây
                          console.log("Vui lòng nhập thời hạn công nợ hợp lệ");
                          return;
                        }
                        handleSaveDebt();
                      }}
                    >
                      Lưu
                    </Button>
                  </Flex>
                </Modal>

                {/* Modal Trả góp */}
                <Modal
                  opened={modalType === "Trả góp"}
                  onClose={handleCloseModal}
                  title="Nhập thông tin Trả góp"
                  centered
                >
                  <Tabs defaultValue="financialCompany">
                    {/* Tab Công ty tài chính */}
                    <Tabs.List>
                      <Tabs.Tab value="financialCompany">
                        Công ty tài chính
                      </Tabs.Tab>
                      <Tabs.Tab value="creditCard">Thẻ tín dụng</Tabs.Tab>
                    </Tabs.List>

                    <Tabs.Panel
                      value="financialCompany"
                      pt="sm"
                      style={{
                        pointerEvents:
                          location?.state?.actionType === "payment" &&
                          orderStatus !== "DON_HANG_HOAN_THANH"
                            ? "auto"
                            : "none",
                      }}
                    >
                      {/* <TextInput
                    label="Tên công ty"
                    placeholder="Nhập tên công ty"
                    withAsterisk
                    value={installmentInfo.companyName}
                    onChange={(e) =>
                      setInstallmentInfo({
                        ...installmentInfo,
                        companyName: e.target.value,
                      })
                    }
                  /> */}

                      <Select
                        label="Tên công ty"
                        placeholder="Chọn công ty"
                        data={[{ value: "hdsaigon", label: "HDSAISON" }]}
                        withAsterisk
                        value={
                          dataPaymentLatter?.installmentInfo?.companyName ||
                          installmentInfo.companyName
                        }
                        onChange={(value) =>
                          setInstallmentInfo({
                            ...installmentInfo,
                            companyName: value || "",
                          })
                        }
                      />
                      <TextInput
                        label="Mã hợp đồng"
                        placeholder="Nhập mã hợp đồng"
                        withAsterisk
                        value={
                          dataPaymentLatter?.installmentInfo?.contractCode ||
                          installmentInfo.contractCode
                        }
                        onChange={(e) =>
                          setInstallmentInfo({
                            ...installmentInfo,
                            contractCode: e.target.value,
                          })
                        }
                      />
                    </Tabs.Panel>

                    {/* Tab Thẻ tín dụng */}
                    <Tabs.Panel
                      value="creditCard"
                      pt="sm"
                      style={{
                        pointerEvents:
                          location?.state?.actionType === "payment" &&
                          orderStatus !== "DON_HANG_HOAN_THANH"
                            ? "auto"
                            : "none",
                      }}
                    >
                      <Select
                        label="Loại thẻ"
                        placeholder="Chọn loại thẻ"
                        data={[
                          { value: "payoo", label: "PAYOO" },
                          { value: "alepay", label: "ALEPAY" },
                        ]}
                        withAsterisk
                        value={
                          dataPaymentLatter?.installmentInfo?.cardType ||
                          installmentInfo.cardType
                        }
                        onChange={(value) =>
                          setInstallmentInfo({
                            ...installmentInfo,
                            cardType: value || "",
                          })
                        }
                      />
                    </Tabs.Panel>
                  </Tabs>

                  <Flex
                    justify="end"
                    mt="lg"
                    style={{
                      pointerEvents:
                        location?.state?.actionType === "payment" &&
                        orderStatus !== "DON_HANG_HOAN_THANH"
                          ? "auto"
                          : "none",
                    }}
                  >
                    <Button onClick={handleCloseModal} color="gray" mr="sm">
                      Hủy
                    </Button>
                    {/* <Button
                  onClick={() => {
                    handleSaveInstallment();
                  }}
                >
                  Lưu
                </Button> */}
                  </Flex>
                </Modal>
              </>
            </Grid>
          </Box>
        )}
        <Box>
          <Grid mt={5}>
            <Grid.Col span={12}>
              <Flex
                gap="xs"
                direction={{ base: "column", sm: "row" }}
                align="center"
                style={{
                  pointerEvents: "auto",
                }}
              >
                {/* Ghi chú đơn hàng */}
                <Textarea
                  readOnly={location?.state?.actionType === "payment"}
                  placeholder="Ghi chú đơn hàng"
                  size="lg"
                  style={{ flex: 1, cursor: "pointer" }}
                  defaultValue={orderHeader?.note || ""}
                  onChange={(e) => debouncedNoteChange(e.target.value)}
                />
                {/* Ghi chú thu ngân */}
                <Textarea
                  readOnly={location?.state?.actionType !== "payment"}
                  placeholder="Ghi chú thu ngân"
                  size="lg"
                  style={{ flex: 1 }}
                  defaultValue={orderHeader?.attribute23 || ""}
                  onChange={(e) => debouncedCashierNoteChange(e.target.value)}
                />
              </Flex>
            </Grid.Col>
          </Grid>
        </Box>
        <Flex columnGap={5}>
          {orderStatus === "DON_HANG_TAM" ? (
            <Flex mt={10} gap={"xs"}>
              {/* <>
                {location?.state?.actionType !== "doi" && (
                  <Button
                    color="blue"
                    size="sm"
                    loading={loading}
                    disabled={
                      listAdd.length === 0 ||
                      location?.state?.actionType === "approved" ||
                      location?.state?.actionType === "view"
                    }
                    onClick={() => handleEditSalesOrder(false)}
                  >
                    Lưu
                  </Button>
                )}
                <Button
                  color="green"
                  size="sm"
                  loading={loading}
                  disabled={
                    listAdd.length === 0 ||
                    location?.state?.actionType === "approved" ||
                    location?.state?.actionType === "view"
                  }
                  onClick={() => handleEditSalesOrder(true)}
                >
                  Chốt đơn
                </Button>
              </> */}
            </Flex>
          ) : (
            orderStatus !== "DON_HANG_HOAN_THANH" && (
              <>
                {location?.state?.actionType === "payment" ? (
                  <>
                    <Flex mt={10} gap={"xs"}>
                      <Button
                        color="green"
                        size="sm"
                        // disabled={deferredPayment < 0}
                        onClick={() => openModalPaymentBase()}
                        mt={10}
                      >
                        Hoàn thành
                      </Button>
                    </Flex>
                  </>
                ) : (
                  <>
                    {/* <Flex mt={10} gap={"xs"}>
                      {location?.state?.actionType !== "doi" && (
                        <Button
                          color="cyan"
                          size="sm"
                          loading={loading}
                          disabled={
                            orderStatus === "DON_HANG_CHOT" ||
                            orderStatus === "DON_HANG_HUY" ||
                            location?.state?.actionType === "approved" ||
                            location?.state?.actionType === "view"
                          }
                          onClick={() => handleCreateSalesOrder(false)}
                        >
                          Lưu
                        </Button>
                      )}
                    </Flex> */}
                    <Flex mt={10} gap={"xs"}>
                      <Button
                        color="green"
                        size="sm"
                        loading={loading}
                        disabled={
                          orderStatus === "DON_HANG_CHOT" ||
                          orderStatus === "DON_HANG_HUY" ||
                          location?.state?.actionType === "approved" ||
                          location?.state?.actionType === "view"
                        }
                        onClick={() => handleCreateSalesOrder(true)}
                      >
                        Chốt đơn
                      </Button>
                    </Flex>
                  </>
                )}
              </>
            )
          )}
          {location?.state?.actionType === "approved" &&
            orderStatus === "DON_HANG_CHO_DUYET_GIAM" && (
              <>
                <Flex mt={10} gap={"xs"}>
                  <Button
                    color="cyan"
                    size="sm"
                    onClick={() => handleApprovedSalesOrder()}
                    style={{ pointerEvents: "auto" }}
                  >
                    Duyệt giảm
                  </Button>
                </Flex>
                <Flex mt={10} gap={"xs"}>
                  <Button
                    color="red"
                    size="sm"
                    onClick={() =>
                      handleDeleteOrder(orderHeader?.orderNumber, "approved")
                    }
                    style={{ pointerEvents: "auto" }}
                  >
                    Không duyệt
                  </Button>
                </Flex>
              </>
            )}
        </Flex>
      </Box>
    );
  };

  //#region openConfirmModal
  function openFormCustomer(isChooseCongNo: boolean) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin danh sách khách hàng</Title>
        </>
      ),
      size: "90vw",
      children: (
        <CustomerInformation
          isChooseCongNo={isChooseCongNo}
          handleChooseCustomer={handleChooseCustomer}
          navigate={navigate}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openFormVoucher(row: MRT_Row<dataOrderDetailTable>) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Màn hình chọn chính sách khuyến mãi</Title>
        </>
      ),
      size: "70vw",
      children: (
        <VoucherRefactor
          branchId={branchId || 0}
          idItem={row?.id}
          price={row.original.priceOnPriceList}
          handleSelectProductAddOn={handleSelectProductAddOn}
          handleSelectProductGift={handleSelectProductGift}
          handleSelectPromotionMain={handleSelectPromotionMain}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const openModalPayment = (priceVnPay: number) =>
    modals.openConfirmModal({
      title: <Title order={5}>Thanh toán VN PAY</Title>,
      children: (
        <PaymentMethod
          price={priceVnPay}
          productCode={orderHeader?.orderNumber}
        />
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "550px",
    });

  const openModalPaymentMb = (price: number, anotherPayment: number) =>
    modals.openConfirmModal({
      title: <Title order={5}>Thanh toán chuyển khoản</Title>,
      children: (
        <PaymentMethodMb
          isDVT={
            listBranch?.find(
              (item: any) => Number(item.value) === Number(branchId),
            )?.attr6 === "DVT"
          }
          isPaymentMbSuccess={isPaymentMbSuccess}
          setIsPaymentMbSuccess={setIsPaymentMbSuccess}
          setTransactionCodeMb={setTransactionCodeMb}
          selectedBankReserve={selectedBankReserve}
          transactionCodeReserve={transactionCodeReserve}
          setTransactionCodeReserve={setTransactionCodeReserve}
          setSelectedBankReserve={setSelectedBankReserve}
          customerCheck={customerCheck}
          orderNumber={orderHeader.orderNumber}
          setPaymentDone={setPaymentDone}
          paymentDone={paymentDone}
          price={price + anotherPayment}
          productCode={orderHeader?.orderNumber}
        />
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "550px",
    });

  const openDeleteConfirmModal = (row: MRT_Row<dataOrderDetailTable>) => {
    return modals.openConfirmModal({
      title: "Bạn có chắc chắn xóa sản phẩm này?",
      children: (
        <Text size="lg" mt={15}>
          Bạn có chắc chắn muốn xóa ?
        </Text>
      ),
      labels: { confirm: "Xóa", cancel: "Thoát" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        const data = listAdd.filter((value) => value.id !== row.original.id);
        setListAdd(data);

        setListAdd((prevData) => {
          // xoá sp
          const data = prevData.filter(
            (item) =>
              item.id !== row.original?.id &&
              //xoá cả quà tặng kèm theo
              !row.original?.listIdGift?.includes(item?.id),
          );

          return data;
        });
      },
    });
  };

  const openModalDeliveryInformation = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Thông tin giao hàng</Title>,
      size: "70%",
      children: (
        <ModalDeliveryInformation
          cod={deferredPayment - orderHeader?.amountPaid}
          readOnly={location?.state?.actionType === "view"}
          shipping={shipping}
          shipingVendor={shipingVendor}
          setShippingVendor={setShipingVendor}
          customerCheck={customerCheck}
          dataDeliveryInformation={dataDeliveryInformation}
          setDataDeliveryInformation={setDataDeliveryInformation}
          branchId={orderHeader?.orgId}
          listAdd={listAdd}
          payType={orderHeader?.attribute24}
          setOrderHeader={setOrderHeader}
          orderHeader={orderHeader}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  function openFormShipCompany() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin đối tác giao vận</Title>
        </>
      ),
      size: "70vw",
      children: <ShipCompanyTable onSelect={handleSelectShipingVendor} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openFormShipDepartment() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin bộ phận giao vận</Title>
        </>
      ),
      size: "400px",
      children: <ChooseShipDepartment onSelect={handleSelectShipingVendor} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const openModalPaymentBase = async () => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận hoàn tất thanh toán</Title>,
      children: (
        <>
          <Flex justify={"end"} gap={20} mt={"sm"}>
            <Button
              color="gray"
              leftSection={<IconWindow size={18} />}
              onClick={() => {
                modals.closeAll();
              }}
            >
              Huỷ
            </Button>
            <Button
              leftSection={<IconCheck size={18} />}
              onClick={() => {
                handleCallApiPayment();
                modals.closeAll();
              }}
            >
              Xác nhận
            </Button>
          </Flex>
        </>
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "400px",
      classNames: {
        title: "custom-modal-title",
        body: "custom-modal-body",
      },
    });
  };

  //#region Table sản phẩm
  const handleChangeRequestReduction = async (
    value: number | string,
    id: number,
    price: number,
  ) => {
    if (branchId) {
      setListAdd((prevList) => {
        return prevList.map((item) => {
          if (item.id === id) {
            const newValue =
              typeof value === "number" ? value : parseFloat(value);
            const validNewValue = isNaN(newValue) ? 0 : newValue;
            const newPriceFinal =
              price - validNewValue - (item.discountAmount || 0); // Thêm discountAmount
            return {
              ...item,
              discountAdded: validNewValue,
              priceFinal: newPriceFinal,
            };
          }
          return item;
        });
      });
    }
  };

  const isReasonEditable = (item: dataOrderDetailTable) => {
    if (item?.lineTyle === "KM" || item?.lineTyle === "DV") {
      return true;
    }

    return (
      !item?.attribute11 && (item?.lineTyle === "HT" || item?.lineTyle === "HD")
    );
  };

  const handleApplyReasonToAll = (value: string) => {
    setBulkReasonValue(value);
    setListAdd((prevData) =>
      prevData.map((item) =>
        isReasonEditable(item) ? { ...item, attribute2: value } : item,
      ),
    );
  };

  const columns = React.useMemo<MRT_ColumnDef<dataOrderDetailTable>[]>(() => {
    return [
      {
        header: "STT",
        enableEditing: false,
        size: 30,
        Cell: ({ renderedCellValue, row }) => (
          <Text>{row.index === -1 ? "" : row.index + 1}</Text>
        ),
      },
      {
        accessorKey: "lineTyle",
        header: "Loại",
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Text>
            <LineType status={row?.original?.lineTyle} />
          </Text>
        ),
        size: 130,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Box style={{ pointerEvents: "auto" }}>
            <Tooltip label={renderedCellValue}>
              <Text w={200} style={{ whiteSpace: "normal" }} lineClamp={2}>
                {renderedCellValue}
              </Text>
            </Tooltip>
          </Box>
        ),
      },
      {
        accessorKey: "attribute13",
        header: "Serial",
        enableEditing: false,
        size: 120,
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip
            label={row.original.attribute13 || ""}
            disabled={!row.original.attribute13}
          >
            <Box style={{ pointerEvents: "auto" }}>
              <TextInput
                disabled={true}
                value={row.original.attribute13}
              ></TextInput>
            </Box>
          </Tooltip>
        ),
      },

      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        enableEditing: isCreating,
        enableSorting: false,
        size: 120,
        Edit: ({ cell, row, table, column }) => {
          return (
            <>
              <Menu
                opened={!!valueDebounced && dataProducts?.length > 0}
                trapFocus={false}
                shadow="md"
                width={"800"}
                position="bottom-start"
              >
                <Menu.Target>
                  <TextInput
                    autoFocus
                    onChange={async (e) => {
                      const _key = e.target.value ?? "";
                      setValueDebounced(_key);
                      handleSearch();
                    }}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                      if (
                        e.key === "Enter" &&
                        dataProducts?.length === 1 &&
                        !listAdd.some(
                          (item) => item.itemCode === e.currentTarget.value,
                        )
                      ) {
                        setValueDebounced("");
                        handleSelectProduct(dataProducts[0], row?.index);
                        table.setCreatingRow(null);
                        handleSearch();
                      }
                    }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  {/* Nút đóng góc trên */}
                  <ActionIcon
                    onClick={() => {
                      setValueDebounced(""); // Đóng menu khi nút đóng được bấm
                      handleSearch();
                    }}
                    style={{
                      position: "absolute",
                      top: 4, // Điều chỉnh khoảng cách từ trên xuống
                      right: 20, // Điều chỉnh khoảng cách từ phải sang
                      zIndex: 11,
                      backgroundColor: "#f5f5f5", // Màu nền nhạt
                      border: "1px solid #ccc", // Viền nhẹ
                      borderRadius: "4%", // Bo tròn hoàn toàn
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)", // Hiệu ứng bóng
                      color: "#000", // Màu biểu tượng
                      width: "22px", // Kích thước nút
                      height: "2px", // Kích thước nút
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease", // Hiệu ứng mượt mà
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#e0e0e0"; // Màu nền khi hover
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Trả về màu nền ban đầu
                    }}
                    variant="transparent"
                  >
                    <IconX size={22} />
                  </ActionIcon>
                  {modeSearch === "SP" ? (
                    <TableSelect
                      dataProducts={dataProducts}
                      onSelectProduct={(product) => {
                        handleSelectProduct(product, row?.index);
                      }}
                      rowIndex={row.index}
                    />
                  ) : (
                    <TableSelectDV
                      dataProducts={dataProducts}
                      onSelectProduct={(product) => {
                        handleSelectProduct(
                          product,
                          row?.index,
                          "DV",
                          isReturnProduct,
                        );
                      }}
                      rowIndex={row.index}
                    />
                  )}
                </Menu.Dropdown>
              </Menu>
            </>
          );
        },
      },
      {
        accessorKey: "attribute23", // Khóa để truy cập dữ liệu
        header: "Mã kho", // Tiêu đề của cột
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return <Text>{row?.original?.attribute23}</Text>; // Hiển thị giá trị
        },
      },
      {
        accessorKey: "primaryUomCode",
        header: "ĐVT",
        enableEditing: false,
        enableSorting: false,
        size: 50,
      },

      {
        accessorKey: "quality",
        header: "Số lượng",
        enableEditing: false,
        enableSorting: false,
        size: 80,
        Cell: ({ renderedCellValue, row }) => (
          <NumberInput
            disabled={
              row?.original?.lineTyle === "HT" && !row?.original?.isNoSerial
            }
            min={-10000}
            max={10000}
            hideControls
            value={row.original.quality}
            onChange={(e) => {
              if (row?.original?.isNoSerial) {
                handleQuantityChangeReturn(e, row);
              } else {
                handleChangeQuantity(e, row);
              }
            }}
            onBlur={(e) => {
              table.setEditingCell(null);
            }}
          />
        ),
      },
      {
        accessorKey: "priceOnPriceList",
        header: "Giá bán lẻ",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => {
          // if (location?.state?.isReadOnly) {
          if (false) {
            // Trạng thái chỉ đọc, không hiển thị gì
            return null;
          }
          if (row.original.lineTyle === "DV") {
            return (
              <Flex direction="column" gap="sm" rowGap={1}>
                <Flex align="center">
                  <NumberInput
                    size="sm"
                    placeholder="Nhập giá"
                    value={row.original.priceOnPriceList}
                    onChange={(value) => {
                      if (value !== null) {
                        // Giới hạn giá trị tối đa là 100 triệu
                        const newValue = Math.min(
                          Number(value) || 0,
                          1000000000,
                        );
                        setListAdd((prevData) =>
                          prevData.map((item, i) =>
                            i === row.index
                              ? {
                                  ...item,
                                  priceFinal: newValue * item?.quality,
                                  priceOnPriceList: newValue,
                                }
                              : item,
                          ),
                        );
                      }
                    }}
                    onKeyDown={(event) => {
                      // Ngăn không cho nhập '-' và 'e'
                      if (
                        event.key === "-" ||
                        event.key === "e" ||
                        event.key === "E"
                      ) {
                        event.preventDefault();
                      }
                    }}
                    hideControls
                    max={100000000} // Thiết lập giá trị tối đa
                    thousandSeparator="."
                    decimalSeparator=","
                    styles={{
                      input: {
                        height: "30px",
                        fontSize: "14px",
                        padding: "4px",
                      },
                    }}
                  />
                </Flex>
              </Flex>
            );
          } else {
            return (
              <Flex direction="column">
                <NumberFormatter
                  value={row.original.priceOnPriceList}
                  thousandSeparator="."
                  decimalSeparator=","
                />
              </Flex>
            );
          }
        },
      },
      {
        header: "KM",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => {
          const [customDiscount, setCustomDiscount] = React.useState<
            number | null
          >(row.original.discountAmount || null);
          const [warning, setWarning] = React.useState<string | null>(null);

          // Hàm cập nhật giá trị vào danh sách
          const handleDiscountChange = (value: number | null) => {
            if (value !== null && value > row.original.priceOnPriceList) {
              setWarning("KM không được lớn hơn giá sản phẩm");
              return;
            }
            setWarning(null);
            setCustomDiscount(value);

            setListAdd((prevData) =>
              prevData.map((item, i) => {
                if (i === row.index) {
                  const updatedDiscountAmount = value || 0;
                  const updatedPriceFinal =
                    row.original.priceOnPriceList -
                    updatedDiscountAmount -
                    (row.original.discountAdded || 0);

                  return {
                    ...item,
                    discountAmount: updatedDiscountAmount,
                    priceFinal: updatedPriceFinal > 0 ? updatedPriceFinal : 0, // Đảm bảo không âm
                  };
                }
                return item;
              }),
            );
          };

          const calculatedDiscount =
            customDiscount ??
            (row.original.discountRate
              ? -(
                  (row.original.discountRate * row.original.priceOnPriceList) /
                  100
                )
              : -(row.original.discountAmount || 0));

          return (
            <Flex
              direction="column"
              align="start"
              style={{
                padding: "5px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                backgroundColor: "#f9f9f9",
                gap: "5px",
              }}
            >
              {/* Giá trị giảm hiển thị */}
              <Flex
                align="center"
                justify="space-between"
                style={{ width: "100%" }}
              >
                <Box style={{ fontWeight: 600 }}>Giảm CTKM:</Box>
                <Box style={{ color: "red", fontWeight: 600, marginRight: 4 }}>
                  <NumberFormatter
                    value={calculatedDiscount}
                    thousandSeparator="."
                    decimalSeparator=","
                  />
                </Box>
              </Flex>

              {/* Ô nhập liệu riêng biệt */}
              <Flex
                align="center"
                justify="space-between"
                style={{ width: "100%" }}
              >
                <Box style={{ fontWeight: 600 }}>Giảm tự nhập:</Box>
                <NumberInput
                  disabled={row?.original?.lineTyle !== "HH"}
                  size="xs"
                  hideControls
                  value={customDiscount ?? ""}
                  onChange={(e) => handleDiscountChange(Number(e) || null)}
                  thousandSeparator="."
                  decimalSeparator=","
                  style={{
                    width: "60px",
                    marginLeft: "4px",
                    borderRadius: "4px",
                  }}
                />
              </Flex>

              {/* Hiển thị cảnh báo nếu có */}
              {warning && (
                <Box
                  style={{
                    color: "orange",
                    fontSize: "12px",
                    marginTop: "5px",
                    textAlign: "center",
                  }}
                >
                  {warning}
                </Box>
              )}
            </Flex>
          );
        },
      },

      {
        accessorKey: "discount",
        header: "Xin giảm",
        enableEditing: false,
        enableSorting: false,
        size: 130,
        Cell: ({ renderedCellValue, row }) => {
          // Tạo hàm debounce với Mantine
          const debouncedHandleChange = useDebouncedCallback(
            (value) => {
              handleChangeRequestReduction(
                value,
                row.original.id,
                row?.original?.priceOnPriceList,
              );
            },
            500, // 300ms là thời gian debounce
          );

          return (
            <NumberInput
              disabled={
                Number(orderHeader?.discountAddedTotal) > 0
                  ? true
                  : false ||
                    row?.original?.lineTyle !== "HH" ||
                    location?.state?.actionType === "payment" ||
                    row?.original?.attribute11 === "G" ||
                    row?.original?.attribute11 === "H"
              }
              style={{ height: 35 }}
              size="sm"
              fw={"500"}
              hideControls
              thousandSeparator="."
              decimalSeparator=","
              value={row.original?.discountAdded}
              onChange={(e) => {
                debouncedHandleChange(e);
              }}
              min={1}
              max={1000000000}
              clampBehavior="strict"
              onKeyDown={handleKeyDown}
              allowDecimal={false}
              allowNegative={false}
            />
          );
        },
      },
      {
        accessorKey: "attribute28", // Khóa để truy cập dữ liệu
        header: "KM phân bổ", // Tiêu đề của cột
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return (
            <NumberFormatter
              value={row?.original?.attribute28 || ""}
              thousandSeparator="."
              decimalSeparator=","
            />
          ); // Hiển thị giá trị
        },
      },
      // {
      //   accessorKey: "attribute29", // Khóa để truy cập dữ liệu
      //   header: "Xin giảm phân bổ", // Tiêu đề của cột
      //   enableEditing: false, // Không cho phép chỉnh sửa
      //   enableSorting: false, // Tắt sắp xếp
      //   size: 80, // Độ rộng của cột
      //   Cell: ({ row }) => {
      //     return (
      //       <NumberFormatter
      //         value={row?.original?.attribute29 || ""}
      //         thousandSeparator="."
      //         decimalSeparator=","
      //       />
      //     );
      //   },
      // },
      {
        accessorKey: "priceFinal",
        header: "Thành tiền",
        size: 80,
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => {
          // if (location?.state?.isReadOnly) {
          if (false) {
            // Trạng thái chỉ đọc, không hiển thị gì
            return null;
          }
          const { priceFinal, quality } = row.original;
          // Đảm bảo không có giá âm
          const displayedPrice = priceFinal * quality;

          return (
            <>
              <NumberFormatter
                value={displayedPrice}
                thousandSeparator="."
                decimalSeparator=","
              />
            </>
          );
        },
      },
      {
        accessorKey: "attribute19",
        header: "Chứng từ gốc",
        enableSorting: false,
        size: 140,
        Cell: ({ row }) => (
          <Input disabled value={row.original.attribute19 || ""} />
        ),
      },
      {
        accessorKey: "attribute20",
        header: "Bảo hành",
        size: 80,
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => {
          return <>{renderedCellValue ? `${renderedCellValue} tháng` : ""}</>;
        },
      },

      // {
      //   accessorKey: "attribute35", // Thành tiền sau bổ
      //   header: "Thành tiền sau bổ", // Tiêu đề của cột
      //   enableEditing: false, // Không cho phép chỉnh sửa
      //   enableSorting: false, // Tắt sắp xếp
      //   size: 80, // Độ rộng của cột
      //   Cell: ({ row }) => {
      //     return (
      //       <NumberFormatter
      //         value={row?.original?.attribute35 || ""}
      //         thousandSeparator="."
      //         decimalSeparator=","
      //       />
      //     );
      //   },
      // },
      {
        accessorKey: "note",
        header: "Ghi chú",
        enableSorting: false,
        enableEditing: false,
        size: 120,
        Cell: ({ row }) => (
          <TextInput
            value={row.original.note || ""}
            onChange={(event) => {
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, note: event.target.value }
                    : item,
                ),
              );
            }}
          />
        ),
      },

      {
        accessorKey: "attribute16",
        header: "Chứng từ DV",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => (
          <TextInput
            disabled={row.original.lineTyle !== "DV"}
            value={row.original.attribute16 || ""}
            onChange={(event) => {
              console.log("event", event);
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute16: event.target.value }
                    : item,
                ),
              );
            }}
          />
        ),
      },
      {
        accessorKey: "attribute17",
        header: "Giá DV",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => (
          <NumberInput
            disabled={row.original.lineTyle !== "DV"}
            value={row.original.attribute17 || 0} // Giá trị mặc định
            onChange={(value) => {
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute17: Number(value) } // Đảm bảo giá trị là số
                    : item,
                ),
              );
            }}
            thousandSeparator="."
            decimalSeparator=","
            hideControls
            min={0}
            step={1000}
            placeholder="Nhập số tiền"
          />
        ),
      },

      {
        accessorKey: "attribute2",
        header: "Đổi/Trả",
        enableSorting: false,
        size: 200,
        Header: () => (
          <Flex direction="column" gap={4}>
            <Text fw={500} size="sm">
              {"Đổi/Trả"}
            </Text>
            <select
              value={bulkReasonValue}
              onChange={(event) =>
                handleApplyReasonToAll(event.currentTarget.value)
              }
              className={styles.selectHeaderStyle}
              style={{ marginLeft: 5 }}
            >
              <option value="" className={styles.optionStyle}>
                {"Chọn chung"}
              </option>
              {optionsReason.map((reason, index) => (
                <option
                  key={index}
                  value={reason.value}
                  className={styles.optionStyle}
                >
                  {reason.label}
                </option>
              ))}
            </select>
          </Flex>
        ),
        Cell: ({ row }) => (
          <select
            disabled={!isReasonEditable(row.original)}
            value={row.original.attribute2}
            onChange={(event) => {
              setListAdd((prevData) => {
                return prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute2: event?.currentTarget?.value }
                    : item,
                );
              });
            }}
            className={styles.selectStyle}
          >
            <option value="" className={styles.optionStyle}>
              Chọn
            </option>

            {/* {[...exchangeReasons, ...returnReasons].map((reason, index) => (
              <option
                key={index}
                value={reason.value}
                className={styles.optionStyle}
              >
                {reason.label}
              </option>
            ))} */}
            {optionsReason.map((reason, index) => (
              <option
                key={index}
                value={reason.value}
                className={styles.optionStyle}
              >
                {reason.label}
              </option>
            ))}
          </select>
        ),
      },

      // {
      //   accessorKey: "attribute22",
      //   header: "Serial đổi",
      //   enableEditing: false,
      //   size: 140,
      //   Cell: ({ row }) => (
      //     <select
      //       disabled={
      //         row?.original?.lineTyle !== "HH" &&
      //         row?.original?.lineTyle !== "DV"
      //       }
      //       value={row?.original?.attribute22 || ""}
      //       onChange={(event) => {
      //         setListAdd((prevData) => {
      //           return prevData.map((item, i) =>
      //             i === row.index
      //               ? { ...item, attribute22: event?.currentTarget?.value }
      //               : item
      //           );
      //         });
      //       }}
      //       className={styles.selectStyle}
      //     >
      //       <option value="" className={styles.optionStyle}>
      //         Chọn
      //       </option>

      //       {listSerial?.map((reason, index) => (
      //         <option
      //           key={index}
      //           value={reason.value}
      //           className={styles.optionStyle}
      //         >
      //           {reason.label}
      //         </option>
      //       ))}
      //     </select>
      //   ),
      // },

      {
        accessorKey: "attribute6",
        header: "Tình trạng",
        enableSorting: false,
        size: 150,
        Cell: ({ row }) =>
          row.original.lineTyle !== "HH" ? (
            <select
              disabled={
                row?.original?.attribute11 === "G" ||
                row?.original?.attribute11 === "H" ||
                row?.original?.attribute11 === "T"
              }
              value={row.original.attribute6}
              onChange={(event) => {
                setListAdd((prevData) => {
                  return prevData.map((item, i) =>
                    i === row.index
                      ? { ...item, attribute6: event?.currentTarget?.value }
                      : item,
                  );
                });
              }}
              className={styles.selectStyle}
            >
              <option value="" className={styles.optionStyle}>
                Chọn
              </option>
              <option value="new" className={styles.optionStyle}>
                Mới 100%
              </option>
              <option value="used" className={styles.optionStyle}>
                Đã sử dụng
              </option>
            </select>
          ) : (
            <Input disabled></Input>
          ),
      },
      {
        accessorKey: "attribute7",
        header: "Phụ kiện",
        enableSorting: false,
        size: 110,
        Cell: ({ row }) =>
          row.original.lineTyle !== "HH" ? (
            <select
              disabled={
                row?.original?.attribute11 === "G" ||
                row?.original?.attribute11 === "H" ||
                row?.original?.attribute11 === "T"
              }
              value={row.original.attribute7}
              onChange={(event) => {
                setListAdd((prevData) => {
                  return prevData.map((item, i) =>
                    i === row.index
                      ? { ...item, attribute7: event?.currentTarget?.value }
                      : item,
                  );
                });
              }}
              className={styles.selectStyle}
            >
              <option value="" className={styles.optionStyle}>
                Chọn
              </option>
              <option value="du" className={styles.optionStyle}>
                Đủ
              </option>
              <option value="thieu" className={styles.optionStyle}>
                Thiếu
              </option>
            </select>
          ) : (
            <Input disabled></Input>
          ),
      },
      {
        accessorKey: "attribute8",
        header: "Trạng thái",
        enableSorting: false,
        size: 180,
        Cell: ({ row }) =>
          row.original.lineTyle !== "HH" ? (
            <select
              disabled={
                row?.original?.attribute11 === "G" ||
                row?.original?.attribute11 === "H" ||
                row?.original?.attribute11 === "T"
              }
              value={row.original.attribute8}
              onChange={(event) => {
                setListAdd((prevData) => {
                  return prevData.map((item, i) =>
                    i === row.index
                      ? { ...item, attribute8: event?.currentTarget?.value }
                      : item,
                  );
                });
              }}
              className={styles.selectStyle}
            >
              <option value="" className={styles.optionStyle}>
                Chọn
              </option>
              <option value="loi" className={styles.optionStyle}>
                Lỗi
              </option>
              <option value="hoat_dong_tot" className={styles.optionStyle}>
                Hoạt động tốt
              </option>
            </select>
          ) : (
            <Input disabled></Input>
          ),
      },
      {
        accessorKey: "attribute4",
        header: "Trả hàng tính phí",
        enableSorting: false,
        size: 110,
        Cell: ({ row }) =>
          row.original.lineTyle !== "HH" ? (
            <select
              disabled={
                row?.original?.attribute11 === "G" ||
                row?.original?.attribute11 === "H" ||
                row?.original?.attribute11 === "T" ||
                row?.original?.lineTyle === "KM"
              }
              value={row.original.attribute4}
              onChange={(event) => {
                const newValue = event?.currentTarget?.value;
                setListAdd((prevData) => {
                  return prevData.map((item, i) => {
                    if (i === row.index) {
                      const discountPercentage =
                        parseFloat(newValue || "0") / 100; // Chuyển đổi % thành số thực
                      const discountValue =
                        (item.priceOnPriceList -
                          item?.discountAdded -
                          ((row.original.discountRate ?? 0) *
                            row.original.priceOnPriceList) /
                            100 -
                          Number(item?.attribute28 || 0) -
                          Number(item?.attribute29 || 0) -
                          item?.discountAmount) *
                        discountPercentage; // Tính giá trị trừ
                      const updatedPriceFinal =
                        item.priceOnPriceList - // Giá ban đầu
                        ((row.original.discountRate ?? 0) *
                          row.original.priceOnPriceList) /
                          100 -
                        Number(item?.attribute28 || 0) -
                        Number(item?.attribute29 || 0) -
                        discountValue - // Trừ giảm giá theo phần trăm
                        parseFloat(item.attribute5 || "0") - // Trừ giảm giá vật lý
                        parseFloat(item.attribute12 || "0") - // Trừ giảm giá KM
                        item.discountAdded - // Trừ giảm giá bổ sung
                        item.discountAmount; // Trừ giảm giá cố định

                      return {
                        ...item,
                        attribute4: newValue, // Cập nhật giá trị attribute4
                        priceFinal: Math.max(updatedPriceFinal, 0), // Đảm bảo không âm
                        attribute37: discountValue, // cập nhật giá trừ theo % bằng tiền mặt
                      };
                    }
                    return item;
                  });
                });
              }}
              className={styles.selectStyle}
            >
              <option value="" className={styles.optionStyle}>
                Chọn
              </option>
              <option value="0" className={styles.optionStyle}>
                0%
              </option>
              <option value="5" className={styles.optionStyle}>
                5%
              </option>
              <option value="10" className={styles.optionStyle}>
                10%
              </option>
              <option value="15" className={styles.optionStyle}>
                15%
              </option>
              <option value="20" className={styles.optionStyle}>
                20%
              </option>
            </select>
          ) : (
            <Input disabled></Input>
          ),
      },
      {
        accessorKey: "attribute5",
        header: "Trừ lỗi vật lý",
        size: 110,
        Cell: ({ row }) =>
          row.original.lineTyle !== "HH" ? (
            <NumberInput
              disabled={
                row?.original?.attribute11 === "G" ||
                row?.original?.attribute11 === "H" ||
                row?.original?.attribute11 === "T" ||
                row?.original?.lineTyle === "KM"
              }
              min={0}
              max={1000000000}
              clampBehavior="strict"
              hideControls
              thousandSeparator="."
              decimalSeparator=","
              value={row.original.attribute5 || ""}
              onChange={(value) => {
                setListAdd((prevData) => {
                  return prevData.map((item, i) => {
                    if (i === row.index) {
                      const discountPercentage =
                        parseFloat(item.attribute4 || "0") / 100; // Chuyển đổi % thành số thực
                      const discountValue =
                        (item.priceOnPriceList -
                          item?.discountAdded -
                          item?.discountAmount) *
                        discountPercentage; // Tính giá trị trừ
                      const updatedPriceFinal =
                        parseFloat(item.priceOnPriceList?.toString() || "0") - // Giá ban đầu
                        discountValue - // Trừ giảm giá theo phần trăm
                        parseFloat(value?.toString() || "0") - // Trừ giảm giá vật lý
                        parseFloat(item.attribute12 || "0") - // Trừ giảm giá KM
                        item.discountAdded - // Trừ giảm giá bổ sung
                        item.discountAmount; // Trừ giảm giá cố định

                      return {
                        ...item,
                        attribute5: value?.toString(), // Cập nhật giá trị attribute5
                        priceFinal: Math.max(updatedPriceFinal, 0), // Đảm bảo không âm
                      };
                    }
                    return item;
                  });
                });
              }}
              allowDecimal={false}
              allowNegative={false}
            />
          ) : (
            <Input disabled></Input>
          ),
      },
      {
        accessorKey: "attribute12",
        header: "Trừ KM",
        size: 110,
        Cell: ({ row }) =>
          row.original.lineTyle !== "HH" ? (
            <NumberInput
              disabled={row?.original?.lineTyle === "KM"}
              min={0}
              max={1000000000}
              clampBehavior="strict"
              hideControls
              thousandSeparator="."
              decimalSeparator=","
              value={row.original.attribute12 || ""}
              onChange={(value) => {
                setListAdd((prevData) => {
                  return prevData.map((item, i) => {
                    if (i === row.index) {
                      const discountPercentage =
                        parseFloat(item.attribute4 || "0") / 100; // Chuyển đổi % thành số thực
                      const discountValue =
                        (item.priceOnPriceList -
                          item?.discountAdded -
                          item?.discountAmount) *
                        discountPercentage; // Tính giá trị trừ
                      const updatedPriceFinal =
                        parseFloat(item.priceOnPriceList?.toString() || "0") - // Giá ban đầu
                        discountValue - // Trừ giảm giá theo phần trăm
                        parseFloat(item.attribute5 || "0") - // Trừ giảm giá vật lý
                        parseFloat(value?.toString() || "0") - // Trừ giảm giá KM
                        item.discountAdded - // Trừ giảm giá bổ sung
                        item.discountAmount; // Trừ giảm giá cố định

                      return {
                        ...item,
                        attribute12: value?.toString(), // Cập nhật giá trị attribute12
                        priceFinal: Math.max(updatedPriceFinal, 0), // Đảm bảo không âm
                      };
                    }
                    return item;
                  });
                });
              }}
              allowDecimal={false}
              allowNegative={false}
            />
          ) : (
            <Input disabled></Input>
          ),
      },
      {
        accessorKey: "attribute9",
        header: "Ghi chú kiểm tra",
        enableSorting: false,
        size: 10,
        Cell: ({ row }) =>
          row.original.lineTyle !== "HH" ? (
            <TextInput
              value={row.original.attribute9 || ""}
              onChange={(event) => {
                setListAdd((prevData) =>
                  prevData.map((item, i) =>
                    i === row.index
                      ? { ...item, attribute9: event.target.value }
                      : item,
                  ),
                );
              }}
            />
          ) : (
            <Input disabled value={row.original.attribute9 || ""} />
          ),
      },
    ];
  }, [
    bulkReasonValue,
    dataProducts,
    isCreating,
    optionsReason,
    orderHeader?.discountAddedTotal,
  ]);

  const table = useMantineReactTable<dataOrderDetailTable>({
    columns,
    data: listAdd,
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "Thao tác",
      },
    },
    positionToolbarAlertBanner: "bottom",
    createDisplayMode: "row",
    editDisplayMode: "cell",
    enableEditing: true,
    enableRowActions: true,
    enableColumnActions: false,
    enableColumnOrdering: false,
    enableTopToolbar: false,
    enableBatchRowSelection: true,
    positionActionsColumn: "last",
    enableExpandAll: false,

    renderRowActions: ({ row, table }) => (
      <Flex gap="4">
        {!row?.original?.attribute11 && (
          <>
            <Tooltip label="Chọn chính sách khuyến mãi">
              <ActionIcon
                color={orange.base}
                variant="outline"
                disabled={
                  row.original?.listIdPromotion?.length < 1 ||
                  !row.original?.listIdPromotion?.length ||
                  row?.original?.lineTyle === "DV"
                }
                onClick={async () => {
                  openFormVoucher(row);
                }}
              >
                <IconDiscount
                  style={{
                    color:
                      row.original?.listIdPromotion?.length < 1 ||
                      !row.original?.listIdPromotion?.length ||
                      row?.original?.lineTyle === "DV"
                        ? "gray"
                        : orange.base,
                  }}
                />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xoá sản phẩm">
              <ActionIcon variant="outline" color="red">
                <IconTrash onClick={() => openDeleteConfirmModal(row)} />
              </ActionIcon>
            </Tooltip>
          </>
        )}
      </Flex>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
          mb={"xs"}
          style={{ opacity: 0 }}
        ></Flex>
      </>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localizationSales,
    getRowId: (row) => row.id?.toString(),
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    initialState: {
      expanded: true,
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-expand"],
        right: ["mrt-row-actions"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },

    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualSorting: false,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        ...styleCellTable(row),
        ...getStyle(true),
      },
    }),
    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        backgroundColor: handleCheckBackgroundColor(
          row?.original?.attribute11 || "",
        ),
      },
    }),
    enablePagination: false,
    enableBottomToolbar: false,
    state: {
      showAlertBanner: isError,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    enableColumnPinning: true,
    mantineTableProps: {},
  });

  //#region useEffect

  // console.log("customerCheck", customerCheck);

  useHotkeys([
    ["mod+J", () => console.log("Toggle color scheme")],
    [
      "ctrl+F5",
      () => {
        //  openNew();
      },
    ],
    [
      "F5",
      () => {
        //  openNew();
      },
    ],
    ["alt+mod+shift+X", () => console.log("Rick roll")],
    [
      "F11",
      () => {
        // openNew(true);
      },
    ],
    ["ctrl+M", () => toggleCollapse()],
  ]);

  // thêm logic bo phan sẽ ăn theo người hưởng số
  useEffect(() => {
    const foundEmployee = listEmployeeSales.find(
      (emp) => emp.id == employeeSalesRevenueId,
    );

    if (foundEmployee?.departmentId) {
      setDepartmentId(foundEmployee?.departmentId);

      // Cập nhật tên bộ phận
      const departmentName = listDepartment.find((item) => {
        return item.departmentId === foundEmployee.departmentId;
      });
      if (departmentName?.name) {
        setDepartment(departmentName.name);
      }
    }
  }, [employeeSalesRevenueId, listEmployeeSales, listDepartment]);

  useEffect(() => {
    const total = [cardPayment, cashPayment, vnpayPayment, bankTransfer]
      .filter((value) => value > 0) // Filter out values that are 0 or less
      .reduce((acc, curr) => acc + curr, 0); // Sum up the remaining values

    setTotalPaid(total);
  }, [cardPayment, cashPayment, vnpayPayment, bankTransfer]);

  useEffect(() => {
    setDeferredPayment(payableAmount - totalPaid);
  }, [payableAmount, totalPaid]);

  useEffect(() => {
    const fetchDataCreate = async () => {
      const url = `/api/v1/CreateSellItem/create?codePrefix=DH&re=1`;
      try {
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success && !orderHeader?.orderNumber) {
          setOrderHeader(response.data.orderHeader);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (orderHeader?.orderNumber || isFetchDataCalledRef.current) return;

    if (
      location?.state?.actionType !== "view" &&
      location?.state?.actionType !== "payment" &&
      location?.state?.actionType !== "edit" &&
      location?.state?.actionType !== "approved" &&
      location?.state?.actionType !== "doi"
    ) {
      fetchDataCreate();
      isFetchDataCalledRef.current = true; // Đặt flag để tránh gọi lại
    }
  }, [orderHeader, location?.state]);

  useEffect(() => {
    if (branchId && branchName) return;
    setBranchId(orderHeader?.orgId || 0);
    const name = listBranch?.find(
      (item: any) => item?.value == orderHeader?.orgId,
    );
    setBranchName(name?.text);
  }, [orderHeader, listBranch]);

  useEffect(() => {
    if (dataAllocate?.length > 0) {
      setListAdd((prevListAdd) => {
        return prevListAdd.map((item) => {
          const matchedAllocation: any = dataAllocate.find(
            (allocation: any) => allocation.itemId === item.itemId,
          );

          if (matchedAllocation) {
            const priceAfterAllocation =
              (item.priceFinal -
                matchedAllocation?.priceAllKM -
                matchedAllocation?.priceAll) *
              item.quality;

            return {
              ...item,
              attribute28: matchedAllocation?.priceAllKM,
              attribute29: matchedAllocation?.priceAll,
              attribute35: priceAfterAllocation.toString() || "", // Thành tiền sau khi phân bổ
            };
          }
          return item; // Trả về item gốc nếu không tìm thấy dữ liệu phù hợp trong dataAllocate
        });
      });
    }
  }, [dataAllocate]);

  useEffect(() => {
    const handleCheckTotalFee = (listAdd: any[]) => {
      let totalFee = 0;
      console.log("12312312123", listAdd);

      listAdd?.forEach((item) => {
        const priceOnPriceList =
          item.priceOnPriceList -
          item?.discountAdded -
          item?.discountAmount -
          (Number(item?.attribute28) || 0) -
          (Number(item?.attribute29) || 0);

        // Trừ theo %
        const discountPercentage = parseFloat(item.attribute4 || "0") / 100;
        const discountValue = priceOnPriceList * discountPercentage;

        // Trừ tiền trực tiếp
        const discountAttribute5 = parseFloat(item.attribute5 || "0");
        const discountAttribute12 = parseFloat(item.attribute12 || "0");

        // Tính tổng phí trừ
        const totalItemFee =
          discountValue + discountAttribute5 + discountAttribute12;

        // Cộng vào tổng phí
        totalFee += totalItemFee;
      });

      return totalFee;
    };
    const handleCheckPayableAmount = (listAdd: any[]) => {
      let priceTotal = 0;

      listAdd?.forEach((item) => {
        priceTotal += (item?.priceOnPriceList || 0) * (item?.quality || 0);
      });

      return priceTotal;
    };
    setListSerial(handleRenderOptionListAdd(listAdd));
    let priceTotal = handleCheckPayableAmount(listAdd);
    let totalFee = handleCheckTotalFee(listAdd);

    setTotalAmount(priceTotal);
    setTotalReturnFee(totalFee);
    let totalXGDetail = listAdd.reduce((acc, item) => {
      const discountAdded = item.discountAdded || 0; // Lấy giá trị xin giảm, mặc định là 0 nếu không có
      return acc + discountAdded * (item.quality || 1); // Cộng dồn vào tổng, nhân với số lượng
    }, 0);
    const totalDiscount = listAdd.reduce((acc, item) => {
      const discountAmount = item.discountAmount || 0; // Lấy giá trị giảm giá, mặc định là 0 nếu không có
      return acc + discountAmount * (item.quality || 1); // Cộng dồn vào tổng, nhân với số lượng
    }, 0);

    const totalDiscountRate = listAdd.reduce((acc, item) => {
      const discountRate = item.discountRate || 0; // Giá trị phần trăm giảm giá
      const price = item.priceOnPriceList || 0; // Giá của sản phẩm
      const quality = item.quality || 1; // Số lượng sản phẩm
      const discountValue = (discountRate / 100) * price * quality; // Tính giá trị giảm giá
      return acc + discountValue; // Cộng dồn vào tổng
    }, 0);

    const totalPhanBo = listAdd?.reduce((total, item) => {
      return (
        total +
        (Number(item?.attribute28) || 0) +
        (Number(item?.attribute29) || 0)
      );
    }, 0);

    setTotalPhanBo(totalPhanBo);

    setTotalXGDetail(totalXGDetail); // Cập nhật tổng xin giảm
    setTotalKM(
      totalDiscount +
        totalDiscountRate +
        (orderHeader?.amountDiscountTotal || 0),
    );
    setTotalKMLine(totalDiscount + totalDiscountRate);
    // shipping fee can come from dataDeliveryInformation (feeShip) or fallback to orderHeader.attributeValue3
    const shippingFee =
      Number(dataDeliveryInformation?.feeShip ?? 0) ||
      Number(orderHeader?.attributeValue3 ?? 0);

    setPayableAmount(
      (priceTotal ?? 0) -
        (totalDiscount ?? 0) -
        (totalDiscountRate ?? 0) -
        (orderHeader?.amountDiscountTotal ?? 0) -
        (totalXGDetail ?? 0) -
        (orderHeader?.discountAddedTotal ?? 0) +
        totalFee +
        totalPhanBo +
        shippingFee,
    );
  }, [listAdd, orderHeader, location?.state?.actionType]);

  // hàm lấy data ban đầu
  useEffect(() => {
    const userLogin = localStorage.getItem("userLogin");

    if (userLogin) {
      const userLoginObject = JSON.parse(userLogin);
      // gán người thanh toán chính là người bấm nút hoàn thành
      setUserLogin(userLoginObject);
    }

    const fetchDataBranch = async () => {
      const response = await repositoryPos.get<
        MessageResponse<TblDMPaymentMethod[]>
      >("/api/v1/TblDmInventory/get-select-branch?auth=false");

      if (response && response.success) {
        let result = response.data;
        setListBranch(result);
      }
    };

    const fetchDataSaleChanelId = async () => {
      const response = await repositoryMdm.get<MessageResponse<any[]>>(
        "/api/v1/TblDmSaleChanel/get-all",
      );

      if (response && response.success) {
        let result = response.data;
        setSaleChanelList(result);
      }
    };

    const fetchAllDepartment = async () => {
      const response = await repositoryPos.get<
        MessageResponse<DepartmentModel[]>
      >(`/api/v1/TblDepartment/get-all`);

      if (response && response.success) {
        let result = response.data;
        setListDepartment(result);
      } else {
      }
    };

    Promise.all([
      fetchDataSaleChanelId(),
      fetchAllDepartment(),
      fetchDataBranch(),
    ]);
  }, []);

  console.log(saleChanelList, "sđsadsấđsadsadsáđá");
  const [searchTrigger, setSearchTrigger] = useState(0);

  useEffect(() => {
    if (!truPhanBo) {
      const updatedList = listAdd.map((item) => ({
        ...item,
        attribute28: "",
        attribute29: "",
      }));
      setListAdd(updatedList);
    }
  }, [truPhanBo]);

  useEffect(() => {
    const fetchItemSell = async () => {
      const keySearch = valueDebounced.toLowerCase();
      const url =
        modeSearch === "SP"
          ? `/api/v1/TblItem/search-sell?inv=${branchId}&key=${keySearch}`
          : `/api/v1/TblItem/search-sell-service?inv=${branchId}&key=${keySearch}`;
      try {
        const searchResult =
          await repositoryPos.get<MessageResponse<ProductModel[]>>(url);
        if (searchResult?.data) {
          setDataProducts(searchResult.data);
        } else {
          setDataProducts([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setDataProducts([]);
      }
    };

    if (valueDebounced && valueDebounced.length > 2) {
      fetchItemSell();
    } else {
      setDataProducts([]);
    }
  }, [valueDebounced, branchId, modeSearch, searchTrigger]);

  const handleSearch = () => {
    setSearchTrigger((prev) => prev + 1); // Kích hoạt lại useEffect
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (270 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  // Noti nếu thanh toán trước hơn thanh toán sau
  // useEffect(() => {
  //   if (
  //     deferredPayment < 0 &&
  //     totalAmount !== 0 &&
  //     location?.state?.actionType !== "doi"
  //   ) {
  //     NotificationExtension.Warn(
  //       "Số tiền thanh toán lớn hơn tổng số tiền cần thanh toán của đơn!"
  //     );
  //   }
  // }, [deferredPayment]);

  //region logic chọn chi nhánh
  // useEffect(() => {
  //   const fetchDepartmentByBanchId = async () => {
  //     if (branchId) {
  //       const response = await repositoryPos.get<MessageResponse<any>>(
  //         `/api/v1/TblDepartment/get-all?branchId=${branchId}`
  //       );
  //       if (response && response.success) {
  //         let result = response.data;
  //         setListDepartment(result);
  //       }
  //     }
  //   };
  //   fetchDepartmentByBanchId();
  // }, [branchId]);

  useEffect(() => {
    const fetchEmployeeByDepartmentId = async () => {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmEmployee/get-all`,
      );
      if (response && response.success) {
        let result = response.data;
        setListEmployeeSales(result);
      }
    };
    fetchEmployeeByDepartmentId();
  }, []);

  //region  logic sửa đơn hàng

  const fetchDetailSaleChanel = async (SaleChanelId: number) => {
    if (SaleChanelId) {
      const response = await repositoryMdm.get<MessageResponse<any>>(
        `/api/v1/TblDmSaleChanel/update?id=${SaleChanelId}`,
      );
      if (response && response.success) {
        let result = response.data;
        setSaleChanel(result?.name);
      }
    }
  };

  const fetchDelivery = async (data: string) => {
    try {
      const parsedData = JSON?.parse(data);
      setDataDeliveryInformation((prev: any) => ({
        ...prev,
        branchId: parsedData?.branchId,
        customerAddress: parsedData?.customerAddress,
        customerCommuneId: parsedData?.customerCommuneId,
        customerDistrictId: parsedData?.customerDistrictId,
        customerId: parsedData?.customerId,
        customerName: parsedData?.customerName,
        customerProvinceId: parsedData?.customerProvinceId,
        depId: parsedData?.depId,
        sourceType: parsedData?.sourceType,
        telephoneNumber: parsedData?.telephoneNumber,
        deliveryAppointmentTime: new Date(),
        deliveryFee: parsedData?.deliveryFee,
        timeDelivery: parsedData?.timeDelivery,
        timeDeliveryTime: parsedData?.timeDeliveryTime,
        weight: parsedData?.weight,
        width: parsedData?.width,
        length: parsedData?.length,
        height: parsedData?.height,
        feeShip: parsedData?.feeShip,
        description: parsedData?.description,
        status: parsedData?.status,
        typeShip: parsedData?.typeShip,
        to_address: parsedData?.to_address,
        distance: parsedData?.distance,
        to_addressid: parsedData?.to_addressid,
        transportName: parsedData?.transportName,
      }));
    } catch (error) {
      console.error("JSON parsing failed:", error);
    }
  };

  useEffect(() => {
    if (
      !location?.state ||
      location?.state?.actionType === "view" ||
      location?.state?.actionType === "doi"
    )
      return;
    const fetchDataPaymentMethod = async () => {
      if (location.state?.orderNumber) {
        const url =
          location?.state?.actionType === "approved"
            ? `/api/v1/CreateSellItem/approve?orderNumber=${location.state?.orderNumber}`
            : location?.state?.actionType === "edit"
              ? `/api/v1/CreateSellItem/edit?orderNumber=${location.state?.orderNumber}`
              : `/api/v1/CreateSellItem/payment?orderNumber=${location.state?.orderNumber}`;

        const response = await repositoryPos.get<MessageResponse<any>>(url);

        if (response && response.success) {
          let result = response.data;
          setOrderHeader({ ...result.orderHeader });
          setOrderStatus(result?.orderHeader?.orderStatus);
          setBranchId(result?.orderHeader?.orgId);
          setShipingVendor(result?.orderHeader?.shipingVendor);
          const branchName = listBranch?.find(
            (item: any) => item?.id == result?.orderHeader?.orgId,
          );

          // Kiểm tra nếu branchName tồn tại trước khi set
          if (branchName) {
            setBranchName(branchName?.text);
          }
          if (!result?.orderDetail) return;
          setListAdd(result.orderDetail);
        }
      }
    };
    fetchDataPaymentMethod();
  }, [location, listBranch]);

  useEffect(() => {
    if (!location?.state) return;

    const handleFetchDataCustomer = async () => {
      const customerId =
        location?.state?.actionType === "doi"
          ? orderHeaderRef?.custId
          : orderHeader?.custId;

      if (customerId) {
        const customerReturn = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmCustomer/get-detail?id=${customerId}`,
        );

        setCustomerCheck((prev) => ({
          ...prev,
          active: customerReturn?.data?.active ?? false,
          address: customerReturn?.data?.address ?? "",
          birthOfDate: customerReturn?.data?.birthOfDate ?? null,
          code: customerReturn?.data?.code ?? "",
          contact: customerReturn?.data?.contact ?? "",
          description: customerReturn?.data?.description ?? "",
          email: customerReturn?.data?.email ?? "",
          fax: customerReturn?.data?.fax ?? "",
          groupId: customerReturn?.data?.groupId ?? 0,
          id: customerReturn?.data?.id ?? 0,
          name: customerReturn?.data?.name ?? "",
          companyName: customerReturn?.data?.companyName ?? "",
          sex: customerReturn?.data?.sex ?? null,
          taxCode: customerReturn?.data?.taxCode ?? "",
          telephoneNumber: customerReturn?.data?.telephoneNumber ?? "",
          type: customerReturn?.data?.type ?? 0,
          attribute1: customerReturn?.data?.attribute1 ?? "",
          attribute4: customerReturn?.data?.attribute4 ?? "",
          // debtLimit: customerReturn?.data?.debtLimit ?? 0,
          // debtTerm: customerReturn?.data?.debtTerm ?? 0,
        }));
      }
    };

    handleFetchDataCustomer();
  }, [orderHeader, location?.state, orderHeaderRef, orderHeader?.custId]);

  useEffect(() => {
    const handleFetchDataCustomer = async () => {
      if (orderHeader?.custId) {
        const customerReturn = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmCustomer/get-detail?id=${orderHeader?.custId}`,
        );

        setCustomerCheck((prev) => ({
          ...prev,
          active: customerReturn?.data?.active ?? false,
          address: customerReturn?.data?.address ?? "",
          birthOfDate: customerReturn?.data?.birthOfDate ?? null,
          code: customerReturn?.data?.code ?? "",
          contact: customerReturn?.data?.contact ?? "",
          description: customerReturn?.data?.description ?? "",
          email: customerReturn?.data?.email ?? "",
          fax: customerReturn?.data?.fax ?? "",
          groupId: customerReturn?.data?.groupId ?? 0,
          id: customerReturn?.data?.id ?? 0,
          name: customerReturn?.data?.name ?? "",
          companyName: customerReturn?.data?.companyName ?? "",
          sex: customerReturn?.data?.sex ?? null,
          taxCode: customerReturn?.data?.taxCode ?? "",
          telephoneNumber: customerReturn?.data?.telephoneNumber ?? "",
          type: customerReturn?.data?.type ?? 0,
          attribute1: customerReturn?.data?.attribute1 ?? "",
          attribute4: customerReturn?.data?.attribute4 ?? "",
          debtLimit: customerReturn?.data?.debtLimit ?? 0,
          debtTerm: customerReturn?.data?.debtTerm ?? 0,
        }));
      }
    };

    handleFetchDataCustomer();
  }, [orderHeader?.custId]);

  useEffect(() => {
    if (location?.state && !location?.state?.orderNumberOld) {
      fetchDetailSaleChanel(orderHeader?.saleChanelId);
      setContractcode(orderHeader?.contractcode);
      fetchDelivery(orderHeader?.attribute1 || "");
      setShipping(orderHeader?.shipngType);
      setAccountantId(orderHeader?.attribute2 || 0);
      handleGetNameAccountantById(orderHeader?.attribute2);
    }
  }, [orderHeader, location]);

  useEffect(() => {
    const fetchDepartment = async (DeptId: number) => {
      setDepartmentId(DeptId);
      const DeptName = listDepartment.find((item) => {
        return item.departmentId === DeptId;
      });
      if (DeptName?.name) {
        setDepartment(DeptName?.name || "");
      }
    };

    const fetchDetailEmployeeSales = async (
      SaleId: number,
      attribute18?: string,
    ) => {
      if (SaleId && SaleId != 0) {
        const response = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmEmployee/detail-employee?id=${SaleId}`,
        );
        if (response && response.success) {
          let result = response.data;
          setEmployeeSalesId(SaleId.toString());
          setEmployeeSalesName(result?.fullName);
          if (
            location?.state?.actionType &&
            location?.state?.actionType !== "payment" &&
            location?.state?.actionType !== "approved" &&
            location?.state?.actionType !== "view" &&
            location?.state?.actionType !== "edit"
          ) {
            setEmployeeSalesRevenueId(SaleId.toString());
            setEmployeeSalesRevenueName(result?.fullName);
          } else {
            if (attribute18 && attribute18 != "0") {
              const response = await repositoryPos.get<MessageResponse<any>>(
                `/api/v1/TblDmEmployee/detail-employee?id=${attribute18}`,
              );
              if (response && response.success) {
                let resultRevenue = response.data;
                setEmployeeSalesRevenueId(attribute18 || "");
                setEmployeeSalesRevenueName(resultRevenue?.fullName);
              }
            } else {
              setEmployeeSalesRevenueId(SaleId.toString());
              setEmployeeSalesRevenueName(result?.fullName);
            }
          }
        }
      }
    };
    fetchDepartment(orderHeader?.deptId);
    fetchDetailEmployeeSales(orderHeader?.saleId, orderHeader?.attribute18);
  }, [
    orderHeader?.deptId,
    orderHeader?.saleId,
    listDepartment,
    location,
    orderHeader?.attribute18,
  ]);

  // logic xem đơn
  useEffect(() => {
    const handleViewSalesOrder = async () => {
      if (
        location?.state?.actionType === "payment" ||
        location?.state?.actionType === "approved"
      ) {
        const url = `/api/v1/CreateSellItem/details?orderNumber=${location.state.orderNumber}`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          if (response?.data?.orderHeader?.shipingVendor) {
            setShipingVendor(response?.data?.orderHeader?.shipingVendor);
          }
        }
      }

      if (location?.state?.actionType === "view") {
        const url = `/api/v1/CreateSellItem/details?orderNumber=${location.state.orderNumber}`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          setOrderHeader({ ...response?.data?.orderHeader });
          setDataPayment(JSON.parse(response?.data?.orderHeader?.attribute9));
          console.log(
            "attribute9",
            JSON.parse(response?.data?.orderHeader?.attribute9),
          );
          if (response?.data?.orderHeader?.shipingVendor) {
            setShipingVendor(response?.data?.orderHeader?.shipingVendor);
          }
          setDataPaymentLatter(
            JSON.parse(response?.data?.orderHeader?.attribute20),
          );
          setPayLaterMethod(
            JSON.parse(response?.data?.orderHeader?.attribute20)
              ?.payLaterMethod,
          );
          setListAdd(response.data.orderDetail);
          setOrderStatus(response?.data?.orderHeader?.orderStatus);
        }
      }
    };

    handleViewSalesOrder();
  }, [location]);

  // logic doi tra
  useEffect(() => {
    const handleViewSalesOrder = async () => {
      if (location?.state?.actionType === "doi") {
        const url = `/api/v1/CreateSellItem/details-return?orderNumber=${location.state.orderNumberOld}&check=false`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          setOrderHeader({ ...response?.data?.orderHeader });
          setOrderHeaderRef({ ...response?.data?.orderHeaderRef });
          setDataPayment(response?.data?.paymentCommands);
          setListAdd(response.data.orderDetail);
          setOrderStatus(response?.data?.orderHeader?.orderStatus);
        }
      }
    };

    handleViewSalesOrder();
  }, [location]);

  // logic build pc

  useEffect(() => {
    if (orderHeader?.attribute19) {
      setListAdd((prevData) => {
        return prevData.map((item, i) => {
          return { ...item, attribute15: "1" };
        });
      });
      isFetchDataCalledRef.current = true;
    }
  }, [orderHeader?.attribute19]);

  // logic thanh toan sau
  useEffect(() => {
    const handlePayLaterMethodChange = (method: string) => {
      setPayLaterMethod(method);

      // Reset thông tin trả góp hoặc công nợ nếu phương thức thanh toán khác được chọn
      if (method !== "Trả góp") {
        setInstallmentInfo({
          installmentType: "",
          companyName: "",
          contractCode: "",
          cardType: "",
        });
      }
      if (method !== "Công nợ") {
        setDebtInfo({
          dueDate: "",
        });
      }
    };
    handlePayLaterMethodChange(payLaterMethod);
  }, [payLaterMethod]);

  useEffect(() => {
    if (
      location?.state?.actionType !== "payment" &&
      location?.state?.actionType !== "view" &&
      location?.state?.actionType !== "approved"
    ) {
      // Reset shippingVendor khi shipping thay đổi
      setShipingVendor("");

      // Cập nhật deliveryFee về 0
      setDataDeliveryInformation((prev: any) => {
        if (!prev) return prev; // Kiểm tra nếu prev là null hoặc undefined
        return {
          ...prev,
          deliveryFee: 0, // Cập nhật deliveryFee về 0
        };
      });
    }
  }, [shipping, location?.state?.actionType]);

  useEffect(() => {
    const fetchDataOptionDoiTrA = async () => {
      try {
        const response = await repositoryMdm.get(
          `/api/v1/TblDmReturnReason/get-all`,
        );
        if (response && response.success) {
          let result = response.data;
          console.log("Return reasons fetched:", result);
          const option = result
            .filter((item: any) => item.active === true) // Chỉ lấy những thằng đang hoạt động
            .map((item: any) => ({
              value: item.code,
              label: item.name,
            }));
          setOptionsReason(option);
        }
      } catch (error) {
        console.log("Error fetching return reasons:", error);
      }
    };
    fetchDataOptionDoiTrA();
  }, []);
  return (
    <Box>
      <div
        style={{
          ...getStyle(true),
        }}
      >
        {titleSell()}
      </div>
      {/* <Counter></Counter> */}
      <PanelGroup direction="horizontal" id="group" style={{ width: "100%" }}>
        <Panel
          defaultSize={
            isCollapse ? 0 : location?.state?.actionType === "view" ? 35 : 45
          }
          minSize={isCollapse ? 0 : 35}
          maxSize={65}
          collapsible
          style={{
            transition: "0.3s ease",
            display: isCollapse ? "none" : "block",
          }}
        >
          <Collapse
            in={!isCollapse}
            transitionDuration={100}
            transitionTimingFunction="ease-in-out"
            h={"100%"}
          >
            <Card h="100%" p={0} shadow="sm" radius="md" withBorder>
              {formOrderHeader()}
            </Card>
          </Collapse>
        </Panel>

        {!isCollapse && <PanelResizeHandle id="resize-handle" />}

        <Panel
          defaultSize={isCollapse ? 100 : 55}
          minSize={35}
          maxSize={isCollapse ? 100 : 65}
          style={{
            width: isCollapse ? "100%" : "auto",
            transition: "width 0.3s ease",
          }}
        >
          <Flex direction={"column"}>
            <MantineReactTable table={table} />

            {/* Thêm thanh hiển thị thông tin đơn hàng ở đây */}
            {/* {!location?.state?.isReadOnly && ( */}
            {true && (
              <Card
                shadow="sm"
                radius="md"
                withBorder
                p="md"
                style={{
                  backgroundColor: "#f9f9f9",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Grid>
                  <Grid.Col span={2} className={styles.orderInfoStyle}>
                    <Text fw={500} className={styles.infoLabelStyle}>
                      Số lượng:
                    </Text>
                    <Text className={styles.infoValueStyle}>
                      {getTotalQuality(listAdd)}
                    </Text>
                  </Grid.Col>
                  <Grid.Col span={2} className={styles.orderInfoStyle}>
                    <Text fw={500} className={styles.infoLabelStyle}>
                      Tổng tiền hàng:
                    </Text>
                    <Text fw={"bold"}>
                      <NumberFormatter
                        value={totalAmount}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Text>
                  </Grid.Col>
                  <Grid.Col span={2} className={styles.orderInfoStyle}>
                    <Text fw={500} className={styles.infoLabelStyle}>
                      Tổng khuyến mãi:
                    </Text>
                    <Text fw={"bold"}>
                      <NumberFormatter
                        value={totalKM === 0 ? 0 : `-${totalKM}`}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Text>
                  </Grid.Col>
                  <Grid.Col span={2} className={styles.orderInfoStyle}>
                    <Text fw={500} className={styles.infoLabelStyle}>
                      Tổng xin giảm:
                    </Text>
                    <Text fw={"bold"}>
                      <NumberFormatter
                        value={
                          (totalXGDetail ?? 0) +
                            (orderHeader?.discountAddedTotal ?? 0) ===
                          0
                            ? 0
                            : `-${
                                (totalXGDetail ?? 0) +
                                (orderHeader?.discountAddedTotal ?? 0)
                              }`
                        }
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Text>
                  </Grid.Col>
                  <Grid.Col span={2} className={styles.orderInfoStyle}>
                    <Text fw={500} className={styles.infoLabelStyle}>
                      Thanh toán:
                    </Text>
                    <Text fw={"bold"} style={{ color: "red" }}>
                      <NumberFormatter
                        value={payableAmount}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Text>
                  </Grid.Col>
                </Grid>
              </Card>
            )}
          </Flex>
        </Panel>
      </PanelGroup>
      <Box display={"none"}>
        <PrintInvoice
          isDVT={
            listBranch?.find(
              (item: any) => Number(item.value) === Number(branchId),
            )?.attr6 === "DVT"
          }
          idPrint={idPrint}
          setIdPrint={setIdPrint}
          isPrinting={isPrinting}
          setIsPrinting={setIsPrinting}
        />
      </Box>
      <ItemSelectionModal
        isVisible={isModalVisible}
        data={modalData}
        onSelectItem={(item) => {
          addItemToList(item); // Gọi hàm thêm sản phẩm vào danh sách
          setIsModalVisible(false); // Đóng modal
        }}
        onClose={() => setIsModalVisible(false)} // Đóng modal
      />
    </Box>
  );
};

export default ReturnOrderAll;
